!(function (e, t) {
    "use strict";
    var o = {},
        n = function () {
            o.toggle.on("click", function (e) {
                var n, i, a;
                window.innerWidth <= 991 && (e.preventDefault(), (n = t(this)), (i = n.next(o.content)), (a = n.find(o.icon)), i.slideToggle(), a.length && a.toggleClass("is-active"));
            });
        };
    e.init = function () {
        (o.toggle = t("[data-accordion-toggle]")), (o.content = t("[data-accordion-content]")), (o.icon = t("[data-accordion-icon]")), (o.footer = t("#site-footer")), n();
    };
})((window.Accordion = window.Accordion || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {},
            n = {},
            i = function (e) {
                var o = t(e.currentTarget),
                    i = o.find('[name="customer[first_name]"]').val(),
                    a = o.find('[name="customer[last_name]"]').val(),
                    r = o.find('[name="customer[email]"]').val();
                if (n.datePicker && n.datePicker.dateSelected) {
                    var s = n.datePicker.dateSelected,
                        l = s.getDate(),
                        c = s.getFullYear() + "-" + (s.getMonth() + 1) + "-" + l;
                    t("#customer_dob_note").val(c);
                }
                Sailthru.integration("userSignUp", { email: r, vars: { first_name: i, last_name: a } });
            },
            a = function () {
                if (!n.datePicker) return null;
                var e = n.datePicker.getFormattedValue().replace(/\//g, "-");
                return e || null;
            };
        e.init = function () {
            (o.register = t(".js-account-register")),
                (o.info = t(".js-account-info")),
                (o.inputs = t(".js-account-register input")),
                o.register.on("submit", i),
                t(".js-account-register").attr("autocomplete", "off"),
                o.info.on("click", ".js-account-info-submit", function (e) {
                    e.preventDefault();
                    var o = a(),
                        n = t("[data-customer]").attr("data-customer");
                    t(".js-account-info-submit").prop("disabled", !0),
                        t.post(window.DOB_API_BASE + "/v1/saveUserDob", { customer_id: n, birth_date: o }).then(function (e) {
                            t(".js-account-info-submit").prop("disabled", !1), t("#dob").removeClass("editable"), t(".js-account-info-submit").hide("style"), t(".account--info-birthday-link").removeAttr();
                        });
                }),
                (function () {
                    if (!t("#dob").length) return null;
                    "" == t("#dob").val().trim() &&
                        (t("#dob").val("Loading..."),
                        t
                            .get(window.DOB_API_BASE + "/v1/getUserDob?email=" + t("#dob").attr("data-customer-email"))
                            .done(function (e) {
                                t("#dob").val(e.birth_date);
                            })
                            .fail(function () {
                                t("#dob").val(""), t("#dob").addClass("editable"), t(".js-account-info-submit").removeAttr("style"), t(".account--info-birthday-link").hide();
                            }));
                })(),
                (function () {
                    if (!window.Cleave || !t("#dob").length) return null;
                    (n.datePicker = new Cleave("#dob", { date: !0, delimiter: "/", datePattern: ["m", "d", "Y"] })),
                        t("#dob").on("change", function () {
                            t("#customer_dob_note").val(a());
                        });
                })();
        };
    })((window.Account = window.Account || {}), jQuery),
    (function (e, t) {
        CartJS.cart;
        e.init = function () {
          if(enable_free_sample_page){
                $('.page-add-to-cart-button').each(function(el, val){
                $(val).click(function(){
                    var variant_id =  $(val).data('id');
                    
                    console.log('variant_id', variant_id)
                    fetch('/cart.js')
                        .then(response => response.json())
                        .then(data => {
                            console.log(data.total_price); // Outputs the cart data in JSON format
                            let cart_sub_total = data.total_price / 100;
                            console.log(cart_sub_total, 'cart_sub_total', free_sample_cart_total_amount, 'free_sample_cart_total_amount');
                            if(cart_sub_total >= free_sample_cart_total_amount){
                                console.log('Free sample product compare price')
                                let cartItemsGift = CartJS.cart.items
                                    let free_sample_cart_total_id_check = false;
                                        $(cartItemsGift).each(function(elem, value){
                                            if(value.id == variant_id){
                                                free_sample_cart_total_id_check = true
                                            }else if(value.gift_card == true){
                                                free_sample_cart_total_id_check = true
                                            }
                                        });
                                        if(!free_sample_cart_total_id_check){
                                            CartJS.addItem(variant_id, 1, {}, {
                                                        "success": function(data, textStatus, jqXHR) {
                                                        console.log("Cart Total free sample product added");
                                                        InlineCart.update(InlineCart.show);
                                                        // window.location.href = "/checkout/"
                                                        },
                                                        "error": function(jqXHR, textStatus, errorThrown) {
                                                            console.log("Cart Total fre sample product Error")
                                                        }
                                            });
                                        }else{
                                            let gift_card_prd_check = false
                                            $(cartItemsGift).each(function(elm, valm){
                                            if(valm.gift_card == true){
                                                gift_card_prd_check = true
                                            }
                                        });
                                        if(gift_card_prd_check){
                                            if(window.innerWidth > 768){
                                                document.getElementById('free_sapling_error_msg').innerHTML = '*Unable to add gift product. Your cart already contains a gift card'
                                            }else {
                                                var prd_error =  $(val).data('error');
                                                document.getElementById(prd_error).innerHTML = '*Unable to add gift product. Your cart already contains a gift card'
                                            }

                                        }else{
                                            window.location.href = "/checkout/"
                                        } 
                                        }

                            }
                        })
                        .catch(error => {
                            console.error('Error fetching cart JSON:', error);
                        });
                })    
        })
          }
        
            t(document).on("click", "[data-add-to-cart]", function (e) {
                e.preventDefault();
                var o = t(e.currentTarget),
                    n = o.attr("data-variant-id") || !1,
                    i = o.closest("form").find("[qty-input]").val() || 1;
                n &&
                    CartJS.addItem(
                        n,
                        i,
                        {},
                        {
                            success: function (e, t, o) {
                                InlineCart.update(InlineCart.show);
                        //    code for Cart total
                        if(gwp_cart_total_enable){
                            setTimeout(() => {
                                fetch('/cart.js')
                                    .then(response => response.json())
                                    .then(data => {
                                        console.log(data, "data")
                                        console.log('data.total_price');
                                        console.log(data.total_price); // Outputs the cart data in JSON format
                                         let cart_sub_total;
                                        // let cart_sub_total = data.total_price / 100
    
    
                                        let check_gift_card = CartJS.cart.items
                                        $(check_gift_card).each(function(elm, value){
                                            if (value.gift_card == true) {
                                                  let gift_card_price =  value.final_price / 100; 
                                                  cart_sub_total = data.total_price / 100;
                                                  cart_sub_total = cart_sub_total - gift_card_price
    
                                            }else{
                                                cart_sub_total = data.total_price / 100
                                            }
                                        })
                                       console.log(cart_sub_total, "check after gift product")
                                        if(cart_sub_total >= gwp_cart_total_amount){
                                            let cartItemsGift = CartJS.cart.items
                                                                    let gift_cart_total_id_check = false;
                                                                    let gift_cart_total_id_check_gift_card = false; 
                                                                        $(cartItemsGift).each(function(elem, value){
                                                                            if(value.id == gwp_cart_total_gift_id){
                                                                                gift_cart_total_id_check = true
                                                                            } else if (value.gift_card == true){
                                                                                gift_cart_total_id_check = true
                                                                            }
                                                                        });
                                                                        console.log(gift_cart_total_id_check, "gift_cart_total_id_check");
                                                                        if(!gift_cart_total_id_check){
                                                                            CartJS.addItem(gwp_cart_total_gift_id, 1, {}, {
                                                                                        "success": function(data, textStatus, jqXHR) {
                                                                                        console.log("Cart Total Gift product added")
                                                                                        },
                                                                                        "error": function(jqXHR, textStatus, errorThrown) {
                                                                                            console.log("Cart Total Gift product Error")
                                                                                        }
                                                                            });
                                                                        }else{
                                                                            $(cartItemsGift).each(function(elem, value){
                                                                            if (value.gift_card == true){
                                                                                gift_cart_total_id_check_gift_card = true
                                                                            }
                                                                            });
                                                                            // Other GWP Products remove
                                                                            if(gift_cart_total_id_check_gift_card){
                                                                                let all_gift_product = $('.line-item-free'); 
                                                                                    all_gift_product.each(function(elm, valm){
                                                                                        setTimeout(function(){
                                                                                            let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                                            CartJS.updateItem(freeItemremov, 0);
                                                                                            console.log("Cart total free product removed")
                                                                                        }, 1000)
                                                                                    });
                                                                            }
                                                                            // let check_other_gwp_one = false, check_other_gwp_two = false, check_other_gwp_three= false , check_other_gwp_four = false, check_other_gwp_cart_total = false; 
                                                                            // console.log(check_other_gwp_one, check_other_gwp_two, check_other_gwp_three, check_other_gwp_four, "Checking")    
                                                                            // $(cartItemsGift).each(function(elem, valm){
                                                                            //             if(valm.id == gwp_coll_one_gift_id){
                                                                            //                 check_other_gwp_one = true
                                                                            //             } else if(valm.id == gwp_coll_two_gift_id){
                                                                            //                 check_other_gwp_two = true
                                                                            //             }  else if(valm.id == gwp_coll_three_gift_id){
                                                                            //                 check_other_gwp_three = true
                                                                            //             } else if(valm.id == gwp_coll_four_gift_id){
                                                                            //                  check_other_gwp_four = true
                                                                            //             }else if(valm.id == gwp_cart_total_gift_id){
                                                                            //                 check_other_gwp_cart_total = true
                                                                            //             }
                                                                            // });
                                                                            // if(check_other_gwp_cart_total){
                                                                            //     setTimeout(function(){
                                                                            //         CartJS.removeItem(gwp_cart_total_gift_id)
                                                                            //         var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_cart_total_gift_id}"]`).attr('data-line-number'));
                                                                            //         CartJS.updateItem(getfree_lineid, 0);
                                                                            //     }, 1000);
                                                                            //     // console.log("Gift card product added", gwp_cart_total_gift_id, getfree_lineid)
                                                                            // }           
                                                                            // if(check_other_gwp_one){
                                                                            //     setTimeout(function(){
                                                                            //         console.log(check_other_gwp_one, "check_other_gwp_one")
                                                                            //         var getfree_lineid_one = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_one_gift_id}"]`).attr('data-line-number'));
                                                                            //         CartJS.updateItem(getfree_lineid_one, 0);
                                                                            //     }, 1000)
                                                                            // }
                                                                            // if(check_other_gwp_two){
                                                                            //     setTimeout(function(){
                                                                            //         console.log(check_other_gwp_one, "check_other_gwp_one2")
                                                                            //         var getfree_lineid_two = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_two_gift_id}"]`).attr('data-line-number'));
                                                                            //         CartJS.updateItem(getfree_lineid_two, 0);
                                                                            //     }, 1000)
                                                                            // }
                                                                            // if(check_other_gwp_three){
                                                                            //     setTimeout(function(){
                                                                            //     console.log(check_other_gwp_one, "check_other_gwp_one3")
                                                                            //     var getfree_lineid_three = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_three_gift_id}"]`).attr('data-line-number'));
                                                                            //     CartJS.updateItem(getfree_lineid_three, 0);
                                                                            // }, 1000)
                                                                            // }
                                                                            // if(check_other_gwp_four){
                                                                            //     setTimeout(function(){
                                                                            //     console.log(check_other_gwp_one, "check_other_gwp_one4")
                                                                            //     var getfree_lineid_four = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_four_gift_id}"]`).attr('data-line-number'));
                                                                            //     CartJS.updateItem(getfree_lineid_four, 0);
                                                                            // }, 1000)
                                                                            // }
                                                                        }
    
                                        }
                                    })
                                    .catch(error => {
                                        console.error('Error fetching cart JSON:', error);
                                    });
                            }, 1000);
                      
                        }
                        //   code for Cart total end


                        //   Collection GWP multiple start
                        if(gwp_one_enable || gwp_two_enable || gwp_three_enable || gwp_four_enable){
                                setTimeout(() => {                
                                    let cart_Items =  document.querySelectorAll("[data-inline-cart] .cart__line-items .line-item"); 
                                    console.log(cart_Items,"cart_Items");
                                    let collectionItem1 = [];
                                    let gift_card = false
                                    $(cart_Items).each(function(el, val){
                                            if(val.classList.contains('line-item-gift-card')){
                                                gift_card = true;
                                            }
                                            let price = $(val).find('.line-item__price').text();
                                            let quantity = $(val).find('[data-line-item-quantity]').val();
                                
                                            price = Number(price.split('$')[1]);
                                            if(val.dataset.collection == gwp_coll_one_title ){
                                                let obj = {
                                                    collection: gwp_coll_one_title,
                                                    price: price ? price * quantity : 0,
                                                    thresold: gwp_coll_one_amount, 
                                                }
                                                collectionItem1.push(obj);
                                            } else if(val.dataset.collection == gwp_coll_two_title){
                                                let obj = {
                                                    collection: gwp_coll_two_title,
                                                    price: price ? price * quantity : 0,
                                                    thresold: gwp_coll_two_amount,
                                                }
                                                collectionItem1.push(obj);
                                            }else if(val.dataset.collection == gwp_coll_three_title){
                                                let obj = {
                                                    collection: gwp_coll_three_title,
                                                    price: price ? price * quantity : 0,
                                                    thresold: gwp_coll_three_amount,
                                                }
                                                collectionItem1.push(obj);
                                            }
                                            else if(val.dataset.collection == gwp_coll_four_title){
                                                let obj = {
                                                    collection: gwp_coll_four_title,
                                                    price: price ? price * quantity : 0,
                                                    thresold: gwp_coll_four_amount
                                                }
                                                collectionItem1.push(obj);
                                            } 
                                    });
                                    const totals = collectionItem1.reduce((acc, item) => {
                                        if (acc[item.collection]) {
                                            acc[item.collection] += item.price;
                                        } else {
                                            acc[item.collection] = item.price;
                                        }
                                        return acc;
                                    }, {});

                                    // console.log(totals, "ADD ITEM____")
                                    if(gwp_one_enable){
                                        if(totals[gwp_coll_one_title] >= gwp_coll_one_amount){
                                            // console.log(totals[gwp_coll_one_title], gwp_coll_one_amount, "Thresold amount 1 add")
                                            if(gwp_coll_one_start <= today_date && gwp_coll_one_end >= today_date){
                                                        let cartItemsGift = CartJS.cart.items
                                                        let gift_one_id_check = false;
                                                            $(cartItemsGift).each(function(elem, value){
                                                                if(value.id == gwp_coll_one_gift_id){
                                                                    gift_one_id_check = true
                                                                }else if (gift_card == true){
                                                                    gift_one_id_check = true
                                                                }
                                                            })
                                                            console.log('gwp_coll_one_gift_id', gwp_coll_one_gift_id)
                                                            if(!gift_one_id_check){
                                                                CartJS.addItem(gwp_coll_one_gift_id, 1, {}, {
                                                                            "success": function(data, textStatus, jqXHR) {
                                                                            console.log("One collection gift product added")
                                                                            },
                                                                            "error": function(jqXHR, textStatus, errorThrown) {
                                                                                console.log("One Error")
                                                                            }
                                                                    });
                                                            }else if (gift_card == true){
                                                                let all_gift_product = $('.line-item-free'); 
                                                                console.log(all_gift_product, "Before all_gift_product")
                                                                all_gift_product.each(function(elm, valm){
                                                                    setTimeout(function(){
                                                                        let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                        CartJS.removeItem(valm.dataset.variantId); 
                                                                        valm.remove(); 
                                                                        CartJS.updateItem(freeItemremov, 0);
                                                                        console.log(elm,valm.dataset.variantId, valm, freeItemremov,  "elm-index")

                                                                    }, 2000)
                                                                    });
                                                                // var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_one_gift_id}"]`).attr('data-line-number'));
                                                                // CartJS.updateItem(getfree_lineid, 0);
                                                            }
                                             }
                                        }
                                    }
                                    if(gwp_two_enable){
                                        if(totals[gwp_coll_two_title] >= gwp_coll_two_amount){
                                            console.log(totals[gwp_coll_two_title], gwp_coll_two_amount, "Thresold amount 2 add")
                                            console.log(gwp_coll_two_title, "ABIB");
                                            if(gwp_coll_two_start <= today_date && gwp_coll_two_end >= today_date){
                                                        let cartItemsGift = CartJS.cart.items
                                                        let gift_two_id_check = false;
                                                            $(cartItemsGift).each(function(elem, value){
                                                                if(value.id == gwp_coll_two_gift_id){
                                                                    gift_two_id_check = true
                                                                }else if (gift_card == true){
                                                                    gift_one_id_check = true
                                                                }
                                                            });
                                                            if(!gift_two_id_check){
                                                                CartJS.addItem(gwp_coll_two_gift_id, 1, {}, {
                                                                            "success": function(data, textStatus, jqXHR) {
                                                                                console.log(gwp_coll_two_gift_id);
                                                                            console.log("Two collection gift product added")
                                                                            },
                                                                            "error": function(jqXHR, textStatus, errorThrown) {
                                                                                console.log("Two Error")
                                                                            }
                                                                    });
                                                            }else if (gift_card == true){
                                                              let all_gift_product = $('.line-item-free'); 
                                                                console.log(all_gift_product, "Before all_gift_product")
                                                                all_gift_product.each(function(elm, valm){
                                                                    setTimeout(function(){
                                                                        let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                        CartJS.removeItem(valm.dataset.variantId); 
                                                                        valm.remove(); 
                                                                        CartJS.updateItem(freeItemremov, 0);
                                                                        console.log(elm,valm.dataset.variantId, valm, freeItemremov,  "elm-index")

                                                                    }, 2000)
                                                                    });
                                                                // var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_two_gift_id}"]`).attr('data-line-number'));
                                                                // CartJS.updateItem(getfree_lineid, 0);
                                                            }
                                                    }
                                                    
                                                } 
                                            }
                                    if(gwp_three_enable){
                                        if(totals[gwp_coll_three_title] >= gwp_coll_three_amount){
                                            console.log(totals[gwp_coll_three_title], gwp_coll_three_amount, "Thresold amount 3 add")
                                            console.log(gwp_coll_three_title, "THREE"); 
                                            if(gwp_coll_three_start <= today_date && gwp_coll_three_end >= today_date){
                                                        let cartItemsGift = CartJS.cart.items
                                                        let gift_three_id_check = false;
                                                            $(cartItemsGift).each(function(elem, value){
                                                                if(value.id == gwp_coll_three_gift_id){
                                                                    gift_three_id_check = true
                                                                }else if (gift_card == true){
                                                                    gift_one_id_check = true
                                                                }
                                                            })
                                                            if(!gift_three_id_check){
                                                                CartJS.addItem(gwp_coll_three_gift_id, 1, {}, {
                                                                            "success": function(data, textStatus, jqXHR) {
                                                                            console.log("Three collection gift product added")
                                                                            },
                                                                            "error": function(jqXHR, textStatus, errorThrown) {
                                                                                console.log("Three Error")
                                                                            }
                                                                    });
                                                            }else if (gift_card == true){
                                                              let all_gift_product = $('.line-item-free'); 
                                                                console.log(all_gift_product, "Before all_gift_product")
                                                                all_gift_product.each(function(elm, valm){
                                                                    setTimeout(function(){
                                                                        let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                        CartJS.removeItem(valm.dataset.variantId); 
                                                                        valm.remove(); 
                                                                        CartJS.updateItem(freeItemremov, 0);
                                                                        console.log(elm,valm.dataset.variantId, valm, freeItemremov,  "elm-index")

                                                                    }, 2000)
                                                                    });
                                                                // var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_three_gift_id}"]`).attr('data-line-number'));
                                                                // CartJS.updateItem(getfree_lineid, 0);
                                                            }
                                             }
                                        }
                                    }
                                    if(gwp_four_enable){
                                        console.log(gwp_four_enable, $(gwp_four_enable), "gwp_four_enable")
                                        if(totals[gwp_coll_four_title] >= gwp_coll_four_amount){
                                            console.log(totals[gwp_coll_four_title], gwp_coll_four_amount, "Thresold amount 4 add")
                                            console.log(gwp_coll_four_title, "FOUR");
                                            if(gwp_coll_four_start <= today_date && gwp_coll_four_end >= today_date){
                                                        let cartItemsGift = CartJS.cart.items
                                                        let gift_four_id_check = false;
                                                            $(cartItemsGift).each(function(elem, value){
                                                                if(value.id == gwp_coll_four_gift_id){
                                                                    gift_four_id_check = true
                                                                }else if (gift_card == true){
                                                                    gift_one_id_check = true
                                                                }
                                                            })
                                                            if(!gift_four_id_check){
                                                                CartJS.addItem(gwp_coll_four_gift_id, 1, {}, {
                                                                            "success": function(data, textStatus, jqXHR) {
                                                                            console.log("Four collection gift product added")
                                                                            },
                                                                            "error": function(jqXHR, textStatus, errorThrown) {
                                                                                console.log("Four Error")
                                                                            }
                                                                    });
                                                            }else if (gift_card == true){
                                                              let all_gift_product = $('.line-item-free'); 
                                                                console.log(all_gift_product, "Before all_gift_product")
                                                                all_gift_product.each(function(elm, valm){
                                                                    setTimeout(function(){
                                                                        let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                        CartJS.removeItem(valm.dataset.variantId); 
                                                                        valm.remove(); 
                                                                        CartJS.updateItem(freeItemremov, 0);
                                                                        console.log(elm,valm.dataset.variantId, valm, freeItemremov,  "elm-index")

                                                                    }, 2000)
                                                                    });
                                                                // var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_four_gift_id}"]`).attr('data-line-number'));
                                                                // CartJS.updateItem(getfree_lineid, 0);
                                                            }
                                             } 
                                        }
                                    }

                                    // console.log(totals,"collectionItem1", collectionItem1)
                                }, 1000);
                            }
                                //   code for collections GWP End
                            },

                            error: function (e, t, o) {
                                alert("Error: " + e.responseJSON.description);
                            },
                        }
                    );
                    if(enable_free_sample_page){
                        setTimeout(function(){
                                    fetch('/cart.js')
                                        .then(response => response.json())
                                        .then(data => {
                                            console.log('data', data.items)
                                            setTimeout(function(){
                                                let check_gift_prd1 = false
                                                let check_gift_card = data.items
                                                    $(check_gift_card).each(function(elm, value){
                                                        if (value.gift_card == true) {
                                                            check_gift_prd1 = true 
                                                        }
                                                    }); 
                                                    if(check_gift_prd1){
                                                        $('#sample-page-trigger').attr('href', '/checkout');
                                                    }else{
                                                        $('#sample-page-trigger').attr('href', '/pages/free-sampling-page');
                                                    }
                                                }, 1000)
                                               
                                            })
                                            .catch(error => {
                                                console.error('Error fetching cart JSON:', error);
                                            });
                                        }, 2000);
                            
                    }    
            }),
                t(document).on("click", "[qty-control]", function (e) {
                    var o = t(e.currentTarget),
                        n = o.closest("form").find("[qty-input]"),
                        i = parseInt(n.val());
                    if (o.hasClass("qty__control--plus")) {
                        var a = i + 1;
                        n.val(a);
                    } else i > 1 && ((a = i - 1), n.val(a));
                });
        };
    })((window.AddToCart = window.AddToCart || {}), jQuery),
    (function (e, t) {
        var o = {},
            n = CartJS.cart;
        e.pendingRequestCount = 0;
        (e.update = function (e) {
            t.get("/cart?view=alt").then(function (t) {
                o.cart.html(t), "function" == typeof e && e();
            });
        }),
            (e.itemCountTotal = function () {
                o.cartItemCount.text(n.item_count);
            }),
            (e.updateCartTotal = function () {
                (formattedCartTotal = (n.total_price / 100).toFixed(2)), o.cartTotal.text("$" + formattedCartTotal);
            }),
            (e.removeItem = function (t) {
                console.log("Item Updated")
                CartJS.updateItemById(t, 0, null, {
                    success: function (t, o, n) {
                        e.update();
                    },
                    error: function (e, t, o) {
                        //window.alert("Sorry, we're unable to do that.\n" + JSON.parse(e.responseText).description);
                    },
                });
            });
        e.init = function () {
            (o.cart = t("[data-cart]")),
                (o.lineItemEntryPoint = t("[data-cart-contents]")),
                (o.cartItemCount = t("[data-cart-item-count]")),
                (o.cartTotal = t("[data-cart-total]")),
                t(document).on("cart.requestStarted", function (t, o) {
                    e.pendingRequestCount += 1;
                    
                    // Block the checkout button while there are pending requests.
                    let btn = document.querySelector('button[name="checkout"]');
                    
                    // if (btn != null) {
                    //   btn.classList.add("disabled-checkout-btn");
                      
                    //   console.log('cart page checkout disabled');
                    // }
                    
                }),
                t(document).on("cart.requestComplete", function (t, o) {
                    e.update(
                      // Enable the checkout button when all pending requests have been completed.  
                      function() {
                        e.pendingRequestCount -= 1;
                        
                        let btn = document.querySelector('button[name="checkout"]');
                        
                        if (btn == null) return;                       
                    
                        if (e.pendingRequestCount == 0) {
                          btn.classList.remove("disabled-checkout-btn");
                          
                          console.log('cart page checkout enabled');
                        } else {
                          // Keeps the button disabled in the updated HTML.
                          // btn.classList.add("disabled-checkout-btn");
                        }
                      }
                    ), 
                    e.itemCountTotal(), 
                    e.updateCartTotal();
                }),
                t(document).on("focusin", "[data-line-item-quantity]", function () {
                    t(void 0).data("val", t(void 0).val());
                }),
                t(document).on("change", "[data-line-item-quantity]", function () {
                    console.log(CartJS.cart, "cart change2"); 
                    var e = t(void 0).val(),
                        o = t(void 0)
                            .closest(".line-item")
                            .attr("data-line-number");
                    CartJS.updateItem(o, e, { success: function (e, t, o) {} });
                console.log(e, t, o, "CART UPDATED___")
             
                 console.log(CartJS.cart, "Cart is updatd"); 
                  // Code for CART TOTAL update start
                 if(gwp_cart_total_enable){
                            fetch('/cart.js')
                                .then(response => response.json())
                                .then(data => {
                                    setTimeout(() => {
                                        console.log(data.total_price,  CartJS.cart.total_price, "Update total");
                                        // let cart_sub_total = data.total_price / 100;

                                        let cart_sub_total;
                                        let check_gift_card = CartJS.cart.items
                                        $(check_gift_card).each(function(elm, value){
                                            if (value.gift_card == true) {
                                                  let gift_card_price =  value.final_price / 100; 
                                                  cart_sub_total = CartJS.cart.total_price / 100;
                                                  cart_sub_total = cart_sub_total - gift_card_price
    
                                            }else{
                                                cart_sub_total = CartJS.cart.total_price / 100
                                            }
                                        })
                                      
                                        console.log('cart_sub_total', cart_sub_total)
  
                                        let cartItemsGift = data.items;
                                        if(cart_sub_total >= gwp_cart_total_amount){
                                                                let gift_cart_total_id_check_update = false;
                                                                    $(cartItemsGift).each(function(elem, value){
                                                                        if(value.id == gwp_cart_total_gift_id){   
                                                                            gift_cart_total_id_check_update = true;
                                                                        }else if(value.gift_card == true){
                                                                            gift_cart_total_id_check_update = true;
                                                                        }
                                                                    });
                                                                    if(!gift_cart_total_id_check_update){
                                                                        CartJS.addItem(gwp_cart_total_gift_id, 1, {}, {
                                                                                    "success": function(data, textStatus, jqXHR) {
                                                                                    console.log("Cart Total Gift product added")
                                                                                    },
                                                                                    "error": function(jqXHR, textStatus, errorThrown) {
                                                                                        console.log("Cart Total Gift product Error")
                                                                                    }
                                                                        });
                                                                    }

                                    }else if(cart_sub_total < gwp_cart_total_amount){
                                          console.log('Update below 100')
                                        let gift_cart_total_id_check_update_gift = false; 
                                                                  $(cartItemsGift).each(function(elem, value){
                                                                        if(value.id == gwp_cart_total_gift_id){   
                                                                            gift_cart_total_id_check_update = true;
                                                                        }else if(value.gift_card == true){
                                                                            gift_cart_total_id_check_update_gift = true;
                                                                        }
                                                                    });
                                                                 if(gift_cart_total_id_check_update_gift){
                                                                     let all_gift_product = $('.line-item-free'); 
                                                                     console.log(all_gift_product, "Before all_gift_product")
                                                                     all_gift_product.each(function(elm, valm){
                                                                         setTimeout(function(){
                                                                             let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                             CartJS.updateItem(freeItemremov, 0);
                                                                             console.log(elm, valm, "elm-index")
                                                                         }, 1000)
                                                                         });
                                                                 }   else{
                                                                   console.log("Cart Total removed1")
                                                                       let all_gift_product = $('.line-item-free'); 
                                                                       console.log(all_gift_product, "Before all_gift_product")
                                                                       all_gift_product.each(function(elm, valm){
                                                                         setTimeout(function(){
                                                                             let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                             CartJS.updateItem(freeItemremov, 0);
                                                                             console.log(elm, valm, "elm-index")
                                                                         }, 1000)
                                                                         });
                                                                       // var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_one_gift_id}"]`).attr('data-line-number'));
                                                                       // console.log("Cart Total removed1", getfree_lineid)
                                                                       // CartJS.updateItem(getfree_lineid, 0);
                                                                 }
                                                                
                                                          

                                     }
                                    }, 2000);
                                })
                                .catch(error => {
                                    console.error('Error fetching cart JSON:', error);
                                });
                      
                        } 
                          // Code for CART TOTAL update end
                
                //  if(gwp_cart_total_enable){
                //             console.log(CartJS.cart.items_subtotal_price) 
                            
                //             if(CartJS.cart.items_subtotal_price >= gwp_cart_total_amount){
                //                 CartJS.addItem(gwp_cart_total_gift_id, 1, {}, {
                //                                                             "success": function(data, textStatus, jqXHR) {
                //                                                             console.log("Cart Total Gift product added")
                //                                                             },
                //                                                             "error": function(jqXHR, textStatus, errorThrown) {
                //                                                                 console.log("Cart Total Gift product Error")
                //                                                             }
                //                      });
                //             }else if(CartJS.cart.items_subtotal_price < gwp_cart_total_amount){
                //                         var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_cart_total_gift_id}"]`).attr('data-line-number'));
                //                         CartJS.updateItem(getfree_lineid, 0);
                //             }
                //         }


               // Code for GWP collection update start
                 if(gwp_one_enable || gwp_two_enable || gwp_three_enable || gwp_four_enable){
                            setTimeout(() => {                
                                let cart_Items =  document.querySelectorAll("[data-inline-cart] .cart__line-items .line-item"); 
                                console.log(cart_Items,"cart_Items");
                                let collectionItem3 = [];
                                let gift_card = false
                                $(cart_Items).each(function(el, val){
                                            if(val.classList.contains('line-item-gift-card')){
                                                gift_card = true;
                                            }
                                        let price = $(val).find('.line-item__price').text();
                                        let quantity = $(val).find('[data-line-item-quantity]').val();
                                        price = Number(price.split('$')[1]);
                                        if(val.dataset.collection == gwp_coll_one_title ){
                                            let obj = {
                                                collection: gwp_coll_one_title,
                                                price: price ? price * quantity : 0,
                                                thresold: gwp_coll_one_amount, 
                                            }
                                            collectionItem3.push(obj);
                                        } else if(val.dataset.collection == gwp_coll_two_title){
                                            let obj = {
                                                collection: gwp_coll_two_title,
                                                price: price ? price * quantity : 0,
                                                thresold: gwp_coll_two_amount,
                                            }
                                            collectionItem3.push(obj);
                                        }else if(val.dataset.collection == gwp_coll_three_title){
                                            let obj = {
                                                collection: gwp_coll_three_title,
                                                price: price ? price * quantity : 0,
                                                thresold: gwp_coll_three_amount,
                                            }
                                            collectionItem3.push(obj);
                                        }
                                        else if(val.dataset.collection == gwp_coll_four_title){
                                            let obj = {
                                                collection: gwp_coll_four_title,
                                                price: price ? price * quantity : 0,
                                                thresold: gwp_coll_four_amount
                                            }
                                            collectionItem3.push(obj);
                                        } 
                                });
                    
                                const totals = collectionItem3.reduce((acc, item) => {
                                    if (acc[item.collection]) {
                                        acc[item.collection] += item.price;
                                    } else {
                                        acc[item.collection] = item.price;
                                    }
                                    return acc;
                                }, {});
                                console.log(totals, "UPDATE ITEM____")
                                if(gwp_one_enable){
                                    if(totals[gwp_coll_one_title] >= gwp_coll_one_amount){
                                        if(gwp_coll_one_start <= today_date && gwp_coll_one_end >= today_date){
                                                    let cartItemsGift = CartJS.cart.items
                                                    let gift_one_id_check = false;
                                                        $(cartItemsGift).each(function(elem, value){
                                                            if(value.id == gwp_coll_one_gift_id){
                                                                gift_one_id_check = true
                                                            }                                                       })
                                                        if(!gift_one_id_check){
                                                            if(totals[gwp_coll_one_title] >= gwp_coll_one_amount){
                                                                CartJS.addItem(gwp_coll_one_gift_id, 1, {}, {
                                                                            "success": function(data, textStatus, jqXHR) {
                                                                            console.log("One collection gift product added")
                                                                            },
                                                                            "error": function(jqXHR, textStatus, errorThrown) {
                                                                                console.log("Two Error")
                                                                            }
                                                                    });
                                                            }
                                                        } else {
                                                            let gift_card_update = false
                                                            $(cartItemsGift).each(function(elem, value){
                                                            if (value.gift_card == true){
                                                                gift_card_update = true
                                                            }
                                                        });
                                                            if (gift_card_update == true){
                                                                let all_gift_product = $('.line-item-free'); 
                                                                all_gift_product.each(function(elm, valm){
                                                                    setTimeout(function(){
                                                                        let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                        CartJS.updateItem(freeItemremov, 0);
                                                                        console.log(elm, valm, "elm-index")
                                                                    }, 1000)
                                                                    });
                                                            }
                                                        }
                                         }
                                    }
                                    else if(totals[gwp_coll_one_title] < gwp_coll_one_amount){

                                        console.log(totals[gwp_coll_one_title], gwp_coll_one_amount, "Thresold amount 1 remove");
                                        var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_one_gift_id}"]`).attr('data-line-number'));
                                        CartJS.updateItem(getfree_lineid, 0);
                                        $(`.line-item-free[data-line-item="${gwp_coll_one_gift_handle}"]`).remove();
                                    }
                                }
                                if(gwp_two_enable){
                                    if(totals[gwp_coll_two_title] >= gwp_coll_two_amount){
                                                console.log(totals[gwp_coll_two_title], gwp_coll_two_amount, "Thresold amount 2 add")
                                                console.log(gwp_coll_two_title, "ABIB");
                                                if(gwp_coll_two_start <= today_date && gwp_coll_two_end >= today_date){
                                                    let cartItemsGift = CartJS.cart.items
                                                    let gift_two_id_check = false;
                                                        $(cartItemsGift).each(function(elem, value){
                                                            if(value.id == gwp_coll_two_gift_id){
                                                                gift_two_id_check = true
                                                            }else if (gift_card == true){
                                                                gift_two_id_check = true
                                                            }
                                                        });
                                                        if(!gift_two_id_check){
                                                            CartJS.addItem(gwp_coll_two_gift_id, 1, {}, {
                                                                        "success": function(data, textStatus, jqXHR) {
                                                                        console.log("Updtae Two collection gift product added")
                                                                        },
                                                                        "error": function(jqXHR, textStatus, errorThrown) {
                                                                            console.log("Two Error")
                                                                        }
                                                                });
                                                        }else if (gift_card == true){
                                                                let all_gift_product = $('.line-item-free'); 
                                                                all_gift_product.each(function(elm, valm){
                                                                    setTimeout(function(){
                                                                        let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                        CartJS.updateItem(freeItemremov, 0);
                                                                        console.log(elm, valm, "elm-index")
                                                                    }, 1000)
                                                                    });
                                                            }
                                                }
                                    } else if(totals[gwp_coll_two_title] < gwp_coll_two_amount){
                                                console.log(totals[gwp_coll_two_title], gwp_coll_two_amount, "Thresold amount 2 remove");
                                                var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_two_gift_id}"]`).attr('data-line-number'));
                                                CartJS.updateItem(getfree_lineid, 0);
                                    }
                                }
                                if(gwp_three_enable){
                                    if(totals[gwp_coll_three_title] >= gwp_coll_three_amount){
                                        console.log(totals[gwp_coll_three_title], gwp_coll_three_amount, "Thresold amount 3 add")
                                        console.log(gwp_coll_three_title, "THREE"); 
                                        if(gwp_coll_three_start <= today_date && gwp_coll_three_end >= today_date){
                                                    let cartItemsGift = CartJS.cart.items
                                                    let gift_three_id_check = false;
                                                        $(cartItemsGift).each(function(elem, value){
                                                            if(value.id == gwp_coll_three_gift_id){
                                                                gift_three_id_check = true
                                                            }else if (gift_card == true){
                                                                gift_three_id_check = true
                                                            }
                                                        })
                                                        if(!gift_three_id_check){
                                                            CartJS.addItem(gwp_coll_three_gift_id, 1, {}, {
                                                                        "success": function(data, textStatus, jqXHR) {
                                                                        console.log("Three collection gift product added")
                                                                        },
                                                                        "error": function(jqXHR, textStatus, errorThrown) {
                                                                            console.log("Two Error")
                                                                        }
                                                                });
                                                        }else if (gift_card == true){
                                                                let all_gift_product = $('.line-item-free'); 
                                                                all_gift_product.each(function(elm, valm){
                                                                    setTimeout(function(){
                                                                        let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                        CartJS.updateItem(freeItemremov, 0);
                                                                        console.log(elm, valm, "elm-index")
                                                                    }, 1000)
                                                                    });
                                                            }
                                         }
                                    }
                                    else if(totals[gwp_coll_three_title] < gwp_coll_three_amount){
                                        console.log(totals[gwp_coll_three_title], gwp_coll_three_amount, "Thresold amount 3 remove");
                                        var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_three_gift_id}"]`).attr('data-line-number'));
                                        CartJS.updateItem(getfree_lineid, 0);
                                        $(`.line-item-free[data-line-item="${gwp_coll_three_gift_handle}"]`).remove();
                                    }
                                }
                                if(gwp_four_enable){
                                    if(totals[gwp_coll_four_title] >= gwp_coll_four_amount){
                                        console.log(totals[gwp_coll_four_title], gwp_coll_four_amount, "Thresold amount 4 update")
                                        console.log(gwp_coll_four_title, "FOUR");
                                        if(gwp_coll_four_start <= today_date && gwp_coll_four_end >= today_date){
                                                    let cartItemsGift = CartJS.cart.items
                                                    let gift_four_id_check = false;
                                                        $(cartItemsGift).each(function(elem, value){
                                                            if(value.id == gwp_coll_four_gift_id){
                                                                gift_four_id_check = true
                                                            }else if (gift_card == true){
                                                                gift_four_id_check = true
                                                            }
                                                        })
                                                        if(!gift_four_id_check){
                                                            CartJS.addItem(gwp_coll_four_gift_id, 1, {}, {
                                                                        "success": function(data, textStatus, jqXHR) {
                                                                        console.log("Four collection gift product added")
                                                                        },
                                                                        "error": function(jqXHR, textStatus, errorThrown) {
                                                                            console.log("Two Error")
                                                                        }
                                                                });
                                                        }else if (gift_card == true){
                                                                let all_gift_product = $('.line-item-free'); 
                                                                all_gift_product.each(function(elm, valm){
                                                                    setTimeout(function(){
                                                                        let freeItemremov = parseInt(valm.dataset.lineNumber)
                                                                        CartJS.updateItem(freeItemremov, 0);
                                                                        console.log(elm, valm, "elm-index")
                                                                    }, 1000)
                                                                    });
                                                            }
                                         } 
                                    }
                                    else if(totals[gwp_coll_four_title] < gwp_coll_four_amount){
                                        console.log(totals[gwp_coll_four_title], gwp_coll_four_amount, "Thresold amount 4 remove update");
                                        var getfree_lineid = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_four_gift_id}"]`).attr('data-line-number'));
                                        CartJS.updateItem(getfree_lineid, 0);
                                        $(`.line-item-free[data-line-item="${gwp_coll_four_gift_handle}"]`).remove();
                                    }
                                }
                               
                            }, 1000);
                 }

                    //  Code for GWP collection update end

                    // Code for free sample update start
                    if(enable_free_sample_page){
                        setTimeout(function(){
                                    fetch('/cart.js')
                                        .then(response => response.json())
                                        .then(data => {
                                                let cart_sub_total;
                                                let check_gift_card = CartJS.cart.items
                                                $(check_gift_card).each(function(elm, value){
                                                    if (value.gift_card == true) {
                                                        let gift_card_price =  value.final_price / 100; 
                                                        cart_sub_total = data.total_price / 100;
                                                        cart_sub_total = cart_sub_total - gift_card_price
            
                                                    }else{
                                                        cart_sub_total = data.total_price / 100
                                                    }
                                                }); 
                                                console.log(cart_sub_total, free_sample_cart_total_amount, "Free sampling total value update", cart_sub_total < free_sample_cart_total_amount)
                                                if(cart_sub_total < free_sample_cart_total_amount){
                                                    console.log("free sample updated")
                                                    $(check_gift_card).each(function(elmm, valmm){
                                                        console.log(elmm, valmm.id, "Updated value", free_sample_product_1, free_sample_product_2, free_sample_product_3, free_sample_product_4)
                                                        setTimeout(function(){
                                                            if(valmm.id == free_sample_product_1){
                                                                console.log('matched 1')
                                                                // e.removeItem(free_sample_product_1), $(`.line-item-free[data-line-item="${free_sample_product_1_handle}"]`).remove();
                                                                var getfree_lineid_1 = parseInt($(`.line-item-free[data-variant-id="${free_sample_product_1}"]`).attr('data-line-number'));
                                                                CartJS.updateItem(getfree_lineid_1, 0);
                                                            }else if(valmm.id == free_sample_product_2){
                                                                console.log('matched 12')
                                                                // e.removeItem(free_sample_product_2), $(`.line-item-free[data-line-item="${free_sample_product_2_handle}"]`).remove();
                                                                var getfree_lineid_2 = parseInt($(`.line-item-free[data-variant-id="${free_sample_product_2}"]`).attr('data-line-number'));
                                                                CartJS.updateItem(getfree_lineid_2, 0);
                                                            }else if(valmm.id == free_sample_product_3){
                                                                console.log('matched 13')
                                                                // e.removeItem(free_sample_product_3), $(`.line-item-free[data-line-item="${free_sample_product_3_handle}"]`).remove();
                                                                var getfree_lineid_3 = parseInt($(`.line-item-free[data-variant-id="${free_sample_product_3}"]`).attr('data-line-number'));
                                                                CartJS.updateItem(getfree_lineid_3, 0);
                                                            }else if(valmm.id == free_sample_product_4){

                                                                console.log('matched 14')
                                                                // e.removeItem(free_sample_product_4), $(`.line-item-free[data-line-item="${free_sample_product_4_handle}"]`).remove();
                                                                var getfree_lineid_4 = parseInt($(`.line-item-free[data-variant-id="${free_sample_product_4}"]`).attr('data-line-number'));
                                                                CartJS.updateItem(getfree_lineid_4, 0);
                                                            }
                                                        }, 1000)
                                                    });
                                                    $('#sample-page-trigger').attr('href', '/checkout');

                                                }else if(cart_sub_total >= free_sample_cart_total_amount){
                                                    $('#sample-page-trigger').attr('href', '/pages/free-sampling-page');
                                                }
                                            })
                                            .catch(error => {
                                                console.error('Error fetching cart JSON:', error);
                                            });
                                        }, 2000);

                    }   
                    // Code for free sample update end
                }),
                e.update();
        };
    })((window.CartPage = window.CartPage || {}), jQuery),
    (function (e, t) {
        "use strict";
        e.init = function () {
            t(".js-afterpay-footer-link").click(function () {
                t("html,body")
                    .stop()
                    .animate({ scrollTop: t(".the-faqs .drawer:nth-child(3)").offset().top + -100 }, "linear"),
                    t(".the-faqs .drawer:nth-child(3)").addClass("open"),
                    t(".the-faqs .drawer:nth-child(3)").attr("id", "klarna-section");
            }),
                location.hash && (t(location.hash), t(".the-faqs .drawer:nth-child(3)").addClass("open")),
                t(window).load(function () {
                    location.hash && t("html,body").animate({ scrollTop: t(".the-faqs .drawer:nth-child(3)").offset().top + -100 }, "linear");
                }),
                t(".the-faqs .drawer:nth-child(3)").attr("id", "klarna-section");
        };
    })((window.FAQs = window.FAQs || {}), jQuery),
    (function (e, t) {
        var o = {};
        (e.show = function () {
            o.mobileFilterToggle.addClass("is-active"), o.mobileFilter.addClass("is-active"), Scroll.lock(), Overlay.show();
        }),
            (e.hide = function () {
                o.mobileFilterToggle.removeClass("is-active"), o.mobileFilter.removeClass("is-active"), Scroll.unlock(), Overlay.hide();
            });
        var n = function () {
                return t("#slider-range").data("highest-price") + 10;
            },
            i = function () {
                var e = t(".container-fluid").innerHeight(),
                    n = t(".mobile-filter-footer").innerHeight(),
                    i = t(".mobile-filter-header").innerHeight(),
                    a = t(window).innerHeight() - e;
                window.innerWidth < 1024
                    ? (t(".filter__wrapper").css({ top: e }).css("height", a), t(".mobile-filter-content").css("height", a - n - i), o.mobileFilterToggle.show())
                    : (t(".filter__wrapper").removeClass("mobile-view"), t("[toggle-mobile-filter]").hide(), Overlay.hide(), o.mobileFilterToggle.removeClass("is-active"), o.mobileFilter.removeClass("is-active"));
            },
            a = function () {
                t("body,html").animate({ scrollTop: t(".collection-grid").offset().top - 140 }, 800);
            },
            r = function () {
                t(".product-badge-product-info").each(function () {
                    var e = t(this);
                    e.children().hasClass("best-seller") && e.children().hasClass("new") && e.find(".badge-item.new").hide();
                }),
                    t('.filter-item:contains("Dryness / Hydration")').remove(),
                    t("[data-trigger]").on("click", function (e) {
                        t(e.currentTarget).siblings("[data-target]").slideToggle().css("overflow", "auto"), t(e.currentTarget).find(".down-arrow").toggleClass("open");
                    }),
                    t(".filter-item").on("click", function (e) {
                        t(".product-grid-item--metafield-container").hide();
                        var o = t(e.currentTarget),
                            n = o.text(),
                            i = o.data("value"),
                            a =
                                '<span class="filtered-item" data-value="' +
                                i +
                                '">' +
                                n +
                                ' <span class="remov-icon"><?xml version="1.0" encoding="UTF-8"?><svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> \x3c!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch --\x3e <title>$ICON / close</title> <desc>Created with Sketch.</desc> <defs></defs> <g id="Collections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.55"> <g id="D-Collections-v1a-/-active-filters" transform="translate(-683.000000, -288.000000)" fill="#000000"> <g id="utility-bar" transform="translate(319.000000, 269.000000)"> <g id="active-filters" transform="translate(80.000000, 0.000000)"> <g id="$ICON-/-close" transform="translate(280.000000, 15.000000)"> <path d="M9.00684932,8.11187215 C8.94292237,8.04794521 8.94292237,7.95205479 9.00684932,7.88812785 L11.4041096,5.49086758 C11.4680365,5.42694064 11.5,5.33105023 11.5,5.26712329 C11.5,5.20319635 11.4680365,5.10730594 11.4041096,5.043379 L10.956621,4.59589041 C10.8926941,4.53196347 10.7968037,4.5 10.7328767,4.5 C10.6369863,4.5 10.5730594,4.53196347 10.5091324,4.59589041 L8.11187215,6.99315068 C8.04794521,7.05707763 7.95205479,7.05707763 7.88812785,6.99315068 L5.49086758,4.59589041 C5.42694064,4.53196347 5.33105023,4.5 5.26712329,4.5 C5.20319635,4.5 5.10730594,4.53196347 5.043379,4.59589041 L4.59589041,5.043379 C4.53196347,5.10730594 4.5,5.20319635 4.5,5.26712329 C4.5,5.33105023 4.53196347,5.42694064 4.59589041,5.49086758 L6.99315068,7.88812785 C7.05707763,7.95205479 7.05707763,8.04794521 6.99315068,8.11187215 L4.59589041,10.5091324 C4.53196347,10.5730594 4.5,10.6689498 4.5,10.7328767 C4.5,10.7968037 4.53196347,10.8926941 4.59589041,10.956621 L5.043379,11.4041096 C5.10730594,11.4680365 5.20319635,11.5 5.26712329,11.5 C5.33105023,11.5 5.42694064,11.4680365 5.49086758,11.4041096 L7.88812785,9.00684932 C7.95205479,8.94292237 8.04794521,8.94292237 8.11187215,9.00684932 L10.5091324,11.4041096 C10.5730594,11.4680365 10.6689498,11.5 10.7328767,11.5 C10.7968037,11.5 10.8926941,11.4680365 10.956621,11.4041096 L11.4041096,10.956621 C11.4680365,10.8926941 11.5,10.7968037 11.5,10.7328767 C11.5,10.6689498 11.4680365,10.5730594 11.4041096,10.5091324 L9.00684932,8.11187215 Z" id="icon-close"></path> </g> </g> </g> </g> </g></svg></span></span>';
                        o.hasClass("mixitup-control-active")
                            ? t("[filtered-items]")
                                  .find('[data-value="' + i + '"]')
                                  .remove()
                            : t("[filtered-items]").append(a),
                            0 == t(".filtered-items").children().length ? t(".clear-filters").addClass("hide-clear-filter-btn") : t(".clear-filters").removeClass("hide-clear-filter-btn"),
                            t(".mixitup-control-active").length > 0 ? t(".clear-filters").show() : t(".clear-filters").hide();
                    }),
                    t(".filtered-items").on("click", ".filtered-item", function (e) {
                        var o = t(e.currentTarget).data("value");
                        t(".filter-item.mixitup-control-active").map(function (e, n) {
                            t(n).data("value") === o && t(n).trigger("click");
                        }),
                            t(e.currentTarget).remove();
                    }),
                    t("[js-sort-by]").on("change", function () {
                        var e = t("[js-sort-by]").val();
                        window.$mixer.sort(e).then(function (e) {
                            return console.log(e.activeSort.sortString);
                        });
                    }),
                    t("[clear-filters]").on("click", function (e) {
                        t("[data-filter-group]").map(function (e, o) {
                            var n = t(o).data("filter-group");
                            window.$mixer.setFilterGroupSelectors(n, []);
                        }),
                            window.$mixer.parseFilterGroups(),
                            t(".clear-filters").hide(),
                            t(".filter-item").removeClass("mixitup-control-active"),
                            t(".filtered-item").remove(),
                            t(".product-grid-item--metafield-container").show();
                    }),
                    t("#slider-range").slider({
                        range: !0,
                        min: 0,
                        max: n(),
                        step: 5,
                        values: [0, n()],
                        slide: function (e, o) {
                            var n = o.values[0],
                                i = o.values[1];
                            t("[min-text]").text("$ " + n), t("[max-text]").text("$ " + i);
                        },
                        change: function (e, t) {
                            var o = (function (e, t) {
                                return Array.from({ length: t + 1 - e }, function (t, o) {
                                    return o + e;
                                }).map(function (e) {
                                    return ".price--" + e;
                                });
                            })(t.values[0], t.values[1]);
                            window.$mixer.setFilterGroupSelectors("price", o), window.$mixer.parseFilterGroups();
                        },
                    }),
                    t(".sort-item").on("click", function (e) {
                        var o = t(e.currentTarget).text();
                        t(".selected-sort-by").text(o);
                    }),
                    o.mobileFilterToggle.on("click", function (o) {
                        t(o.currentTarget).hasClass("is-active") ? e.hide() : e.show();
                    }),
                    t(window).on("resize", function () {
                        i();
                    });
            };
        e.init = function () {
            var e, n;
            (o.mobileFilterToggle = t("[toggle-mobile-filter]")),
                (o.mobileFilter = t("[data-mobile-filter]")),
                r(),
                (e = t("#slider-range").slider("values", 0)),
                (n = t("#slider-range").slider("values", 1)),
                t("[min-text]").text("$" + e),
                t("[max-text]").text("$" + n),
                (function () {
                    let limit = (1024 <= window.innerWidth && window.innerWidth < 1200) ? 39 : 40;
              
                    if (1200 <= window.innerWidth) {
                      // Desktop, each banner takes the space of two products
                      limit -= document.querySelectorAll(".mixitup-container .desktop-banner").length * 2;
                      
                    } else if (1024 <= window.innerWidth) {
                      // Desktop, each banner takes the space of one product
                      limit -= document.querySelectorAll(".mixitup-container .desktop-banner").length;

                    } else {
                      // Mobile
                      limit -= document.querySelectorAll(".mixitup-container .mobile-banner").length;
                    }
                  
                    window.$mixer = mixitup(".mixitup-container", {
                        multifilter: { enable: !0 },
                        callbacks: {
                            onMixStart: function (e) {
                                t(".js-no-collection-results").fadeOut(), a();
                            },
                            onMixEnd: function (e) {
                                t("[matching-items]").text(e.totalMatching), e.totalMatching < 1 ? t("[data-no-results]").fadeIn() : t("[data-no-results]").fadeOut();
                            },
                        },
                        controls: { toggleLogic: "or" },
                        pagination: { limit: limit, hidePageListIfSinglePage: !0 },
                        templates: {
                            pagerPrev:
                                '<button type="button" class="${classNames}" data-page="prev"><?xml version="1.0" encoding="UTF-8"?><svg width="6.25px" height="10px" viewBox="0 0 5 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Collections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="D-Collections-v1a-/-active-filters" transform="translate(-1057.000000, -288.000000)" fill="#8C8C8C"> <g id="utility-bar" transform="translate(319.000000, 269.000000)"> <g id="pagination" transform="translate(738.000000, 5.000000)"> <g id="$ICON-/-arrow-left" transform="translate(2.500000, 18.000000) rotate(-270.000000) translate(-2.500000, -18.000000) translate(-1.500000, 15.500000)"> <path d="M4.1429849,4.70326016 L7.70187818,1.14436688 C7.78567264,1.06057242 7.78567264,0.926185065 7.70187818,0.842390599 C7.61808371,0.758596132 7.48369636,0.758596132 7.39990189,0.842390599 L3.99278727,4.24950522 L0.585672643,0.842390599 C0.501878176,0.758596132 0.367490824,0.758596132 0.283696358,0.842390599 C0.242589639,0.883497318 0.220455251,0.938833286 0.220455251,0.992588227 C0.220455251,1.04634317 0.241008611,1.10167914 0.283696358,1.14278586 L3.84258964,4.70167914 C3.92480308,4.7854736 4.06077146,4.7854736 4.1429849,4.70326016 Z" id="icon-arrow-down"></path> </g> </g> </g> </g> </g></svg></button>',
                            pagerNext:
                                '<button type="button" class="${classNames}" data-page="next"><?xml version="1.0" encoding="UTF-8"?><svg width="6.25px" height="10px" viewBox="0 0 5 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Collections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="D-Collections-v1a-/-active-filters" transform="translate(-1108.000000, -288.000000)" fill="#8C8C8C"> <g id="utility-bar" transform="translate(319.000000, 269.000000)"> <g id="pagination" transform="translate(738.000000, 5.000000)"> <g id="$ICON-/-arrow-right" transform="translate(53.500000, 18.000000) rotate(-90.000000) translate(-53.500000, -18.000000) translate(49.500000, 15.500000)"> <path d="M4.1429849,4.70326016 L7.70187818,1.14436688 C7.78567264,1.06057242 7.78567264,0.926185065 7.70187818,0.842390599 C7.61808371,0.758596132 7.48369636,0.758596132 7.39990189,0.842390599 L3.99278727,4.24950522 L0.585672643,0.842390599 C0.501878176,0.758596132 0.367490824,0.758596132 0.283696358,0.842390599 C0.242589639,0.883497318 0.220455251,0.938833286 0.220455251,0.992588227 C0.220455251,1.04634317 0.241008611,1.10167914 0.283696358,1.14278586 L3.84258964,4.70167914 C3.92480308,4.7854736 4.06077146,4.7854736 4.1429849,4.70326016 Z" id="icon-arrow-down"></path> </g> </g> </g> </g> </g></svg></button>',
                        },
                    });
                    var e = window.$mixer.getState().totalMatching;
                    t("[matching-items]").text(e);
                })(),
                i();
        };
    })((window.Filter = window.Filter || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {},
            n = function () {
                o.newsletterForm.on("click", function (e) {
                    var n;
                    o.placeholder.hasClass("active") || ((n = e.target), (t(n).hasClass("email") || t(n).hasClass("placeholder")) && (o.placeholder.addClass("active"), o.emailInput.focus()));
                }),
                    o.body.on("click", function (e) {
                        var n;
                        o.placeholder.hasClass("active") &&
                            ((n = e.target),
                            t(n).hasClass("email") ||
                                t(n).hasClass("placeholder") ||
                                t(n).hasClass("footer-newsletter__submit") ||
                                0 != document.querySelector("#site-footer input[type=email]").value.length ||
                                o.placeholder.removeClass("active"));
                    });
            };
        e.init = function () {
            (o.newsletterForm = t(".footer-newsletter__form")),
                (o.emailInput = t(".footer-newsletter__group input[type=email]")),
                (o.newsletterFormGroup = t(".footer-newsletter__group")),
                (o.placeholder = t(".footer-newsletter__placeholder")),
                (o.body = t("body")),
                n();
        };
    })((window.Footer = window.Footer || {}), jQuery),
    (function (e, t) {
        CartJS.cart;
        var o = {},
            n = {};
        !1 === o.freeGiftFromProductEnabled &&
            !1 === o.freeGiftFromPrice.enable &&
            !1 === o.freeGiftFromCount.enable &&
            !1 === o.freeGiftFromType.enable &&
            !1 === o.freeGiftFromCollection.enable &&
            !1 === o.freeGiftFromVendor.enable &&
            !1 === o.freeSampleFromPrice.enable &&
            !1 === o.freeSampleFromPrice2.enable &&
            !1 === o.freeSampling.enable &&
            CartJS.cart.items.forEach(function (e) {
                "Free Gift" === e.product_type && CartJS.removeItemById(e.id);
            });
      
        let isPriceReached = function(trigger, cart) {
          let price = cart.total_price;
          
          for (let item of cart.items) {
            price -= ("Gift Card" === item.product_type) ? e.line_price : 0;
          }

          // CartJS uses cents for item prices.
          const minPrice = 100 * parseFloat(trigger, 10);
            
          return isNaN(minPrice) || price >= minPrice;
        };
                                             
        var i = function () {
                !1 === o.freeGiftFromProductEnabled &&
                    !1 === o.freeGiftFromPrice.enable &&
                    !1 === o.freeGiftFromCount.enable &&
                    !1 === o.freeGiftFromType.enable &&
                    !1 === o.freeGiftFromVendor.enable &&
                    !1 === o.freeSampleFromPrice.enable &&
                    !1 === o.freeSampleFromPrice2.enable &&
                    !1 === o.freeSampling.enable &&
                    CartJS.cart.items.forEach(function (e) {
                        ("Free Gift" !== e.product_type && "Gift With Purchase" !== e.product_type && "Sample" !== e.product_type) || CartJS.removeItemById(e.id);
                    });
            },
            a = function () {
                o.freeGiftFromProduct.enable && console.log("🎁Active Promo: GWP - Product"),
                    o.freeGiftFromPrice.enable && console.log("🎁Active Promo: GWP - Cart Total "),
                    o.freeGiftFromCount.enable && console.log("🎁Active Promo: GWP - Cart Count"),
                    o.freeGiftFromType.enable && console.log("🎁Active Promo: GWP - Product Type"),
                    o.freeGiftFromCollection.enable && console.log("🎁Active Promo: GWP - From Collection"),
                    o.freeGiftFromVendor.enable && console.log("🎁Active Promo: GWP - Product Vendor"),
                    t(document).on("cart.requestComplete", function (e, n) {
                  		if (o.freeGiftFromProduct.enable) {
                          (function (e, o) {
                                  var n = e.trigger,
                                      i = e.giftId,
                                      a = e.giftHandle,
                                      r = !1,
                                      s = !1,
                                      l = e.startDate;
                                  console.log("Start date: " + l);
                                  var c = e.endDate;
                                  console.log("End date: " + c);
                                  var d = new Date(),
                                      u = ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "/" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
                                  console.log("Today's date: " + u),
                                      u >= l &&
                                          u < c &&
                                          t
                                              .getJSON("/products/" + a + ".js", function () {})
                                              .done(function () {
                                                  if (
                                                      (o.items.forEach(function (e) {
                                                          n === e.variant_id.toString() && (r = !0), e.variant_id === parseInt(i, 10) && (s = !0);
                                                      }),
                                                      r && !s && isPriceReached(e.minPrice, o))
                                                  ) {
                                                      let e = {};
                                                      (e[i] = 1), CartJS.updateItemQuantitiesById(e);
                                                      console.log('adding gift from product');
                                                  } else (!r || !isPriceReached(e.minPrice, o)) && s && (CartJS.removeItemById(i), console.log('gift from product removed'));
                                              });
                          })(o.freeGiftFromProduct, n)
                      }
                  
                  	// 	if (o.freeGiftFromPrice.enable) {
					// 		            (function (e, o) {
                    //               var n = e.giftId,
                    //                   i = e.giftHandle,
                    //                   a = e.trigger,
                    //                   r = 100 * parseInt(a, 10),
                    //                   s = !1,
                    //                   l = !1,
                    //                   c = !1,
                    //                   d = void 0,
                    //                   u = o.total_price,
                    //                   f = [],
                    //                   g = e.startDate;
                    //                   console.log(s, "SSS");
                    //               console.log("Start date: " + g);
                    //               var p = e.endDate;
                    //               console.log("End date: " + p);
                    //               var h = new Date(),
                    //                   m = ("0" + (h.getMonth() + 1)).slice(-2) + "/" + ("0" + h.getDate()).slice(-2) + "/" + h.getFullYear() + " " + h.getHours() + ":" + h.getMinutes();
                    //               console.log("Today's date: " + m),
                    //                   o.items.forEach(function (e) {
                    //                       "Gift Card" === e.product_type && ((d = e.line_price), f.push(d), (c = !0));
                    //                   }),
                    //                   c &&
                    //                       ((u -= f.reduce(function (e, t) {
                    //                           return e + t;
                    //                       })),
                    //                       console.log("New Total Price: " + u)),
                    //                   m >= g &&
                    //                       m < p &&
                    //                       t.getJSON("/products/" + i + ".js").done(function () {
                    //                           if (
                    //                               (u >= r && (s = !0),
                    //                               o.items.forEach(function (e) {
                    //                                   e.variant_id === parseInt(n, 10) && (l = !0);
                    //                                 //   console.log(e.variant_id === parseInt(n, 10) && (l = !0), "Cart total__________")
                    //                               }),
                    //                               s && !l)
                    //                           ) {
                    //                               let e = {};
                    //                               (e[n] = 1), console.log('adding gift from price'), CartJS.updateItemQuantitiesById(e);
                    //                           } else !s && l && CartJS.removeItemById(n) && console.log('gift from price removed');
                    //                       });
                    //     	})(o.freeGiftFromPrice, n)
                    //   }
                      
                      if (o.freeGiftFromCount.enable) {
                          (function (e, o) {
                                  var n = e.giftId,
                                      i = e.giftHandle,
                                      a = parseInt(e.trigger),
                                      r = !1,
                                      s = !1,
                                      l = !1,
                                      c = o.item_count,
                                      d = [],
                                      u = e.startDate,
                                      f = e.endDate,
                                      g = new Date(),
                                      p = ("0" + (g.getMonth() + 1)).slice(-2) + "/" + ("0" + g.getDate()).slice(-2) + "/" + g.getFullYear() + " " + g.getHours() + ":" + g.getMinutes();
                                  o.items.forEach(function (e) {
                                      "Gift Card" === e.product_type && ((countOfGiftCard = e.quantity), d.push(countOfGiftCard), (l = !0));
                                      // Don't consider gift quantity in the cart item count.
                                      e.variant_id === parseInt(n, 10) && (d.push(e.quantity), (l = !0));
                                  }),
                                      l &&
                                          ((c -= d.reduce(function (e, t) {
                                              return e + t;
                                          })),
                                          console.log("New Total Count: " + c)),
                                      p >= u &&
                                          p < f &&
                                          (console.log("Today's date: " + p),
                                          o.items.forEach(function (e) {
                                              0 === e.price && c--;
                                          }),
                                          t.getJSON("/products/" + i + ".js").done(function () {
                                              if (
                                                  (c >= a && (r = !0),
                                                  o.items.forEach(function (e) {
                                                      e.variant_id === parseInt(n, 10) && (s = !0);
                                                  }),
                                                  r && !s && isPriceReached(e.minPrice, o))
                                              ) {
                                                  let e = {};
                                                  (e[n] = 1), CartJS.updateItemQuantitiesById(e, { is_free_gift: "true" });
                                              } else
                                                  (!r || !isPriceReached(e.minPrice, o)) &&
                                                      s &&
                                                      (CartJS.removeItemById(n),
                                                      CartJS.removeItemById(n, {
                                                          success: function (e, o, i) {
                                                              t('[data-variant-id="' + n + '"]').remove();
                                                          },
                                                      }));
                                          }));
                          })(o.freeGiftFromCount, n)
                      }
                      
                      if (o.freeGiftFromType.enable) {
                          (function (e, o) {
                                  var n = e.giftId,
                                      i = e.giftHandle,
                                      a = e.trigger,
                                      r = !1,
                                      s = !1,
                                      l = e.startDate;
                                  console.log("Start date: " + l);
                                  var c = e.endDate;
                                  console.log("End date: " + c);
                                  var d = new Date(),
                                      u = ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "/" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
                                  console.log("Today's date: " + u),
                                      u >= l &&
                                          u < c &&
                                          t.getJSON("/products/" + i + ".js").done(function () {
                                              if (
                                                  (o.items.forEach(function (e) {
                                                      e.variant_id === parseInt(n, 10) && (s = !0);
                                                      // Only check the product type of items that are not the gift item.
                                                      e.product_type === a && e.variant_id !== parseInt(n, 10) && (r = !0);
                                                  }),
                                                  r && !s && isPriceReached(e.minPrice, o))
                                              ) {
                                                  let e = {};
                                                  (e[n] = 1), CartJS.updateItemQuantitiesById(e);
                                              } else (!r || !isPriceReached(e.minPrice, o)) && s && CartJS.removeItemById(n);
                                          });
                          })(o.freeGiftFromType, n)
                      }
                      
                      if (o.freeGiftFromCollection.enable) {
                          (function (e, o) {
                                  var n = e.giftId,
                                      i = e.giftHandle,
                                      a = e.trigger,
                                      r = !1,
                                      s = !1,
                                      l = e.startDate;
                                  console.log("Start date: " + l);
                                  var c = e.endDate;
                                  console.log("End date: " + c);
                                  var d = new Date(),
                                      u = ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "/" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
                                  console.log("Today's date: " + u),
                                      u >= l &&
                                          u < c &&
                                          t.getJSON("/products/" + i + ".js").done(function () {
                                            console.log("Collection gift product added")
                                              if (
                                                  (o.items.forEach(function (e) {
                                                    console.log(o.items, "o.items")
                                                      e.variant_id === parseInt(n, 10) && (s = !0);
                                                      console.log(e.variant_id, parseInt(n, 10),  (s = !0),  "CollectionsProduct")
                                                      // Only check items in the collection that are not the gift item.
                                                      console.log(a, "Collection____")
                                                     a.indexOf(e.handle) !== -1 && e.variant_id !== parseInt(n, 10) && (r = !0);
                                                     console.log(r && !s && isPriceReached(e.minPrice, o), "Is Price Reached")
                                                  }), r && !s && isPriceReached(e.minPrice, o) )
                                              ) {
                                                  let e = {};
                                                  (e[n] = 1), CartJS.updateItemQuantitiesById(e);
                                              } else (!r || !isPriceReached(e.minPrice, o)) && s && CartJS.removeItemById(n);
                                          });
                          })(o.freeGiftFromCollection, n)
                      }
                      
                      if (o.freeGiftFromVendor.enable) {
                          (function (e, o) {
                                  var n = e.giftId,
                                      i = e.giftHandle,
                                      a = e.trigger,
                                      r = !1,
                                      s = !1,
                                      l = e.startDate;
                                  console.log("Start date: " + l);
                                  var c = e.endDate;
                                  console.log("End date: " + c);
                                  var d = new Date(),
                                      u = ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "/" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
                                  console.log("Today's date: " + u),
                                      u >= l &&
                                          u < c &&
                                          t.getJSON("/products/" + i + ".js").done(function () {
                                              if (
                                                  (o.items.forEach(function (e) {
                                                      e.variant_id === parseInt(n, 10) && (s = !0);
                                                      // Only check from the vendor that are not the gift item.
                                                      e.vendor === a && e.variant_id !== parseInt(n, 10) && (r = !0);
                                                  }),
                                                  r && !s && isPriceReached(e.minPrice, o))
                                              ) {
                                                  let e = {};
                                                  (e[n] = 1), CartJS.updateItemQuantitiesById(e);
                                              } else (!r || !isPriceReached(e.minPrice, o)) && s && CartJS.removeItemById(n);
                                          });
                            })(o.freeGiftFromVendor, n)
                      }
                      
                      i();
                    });
            },
            r = function () {
                o.freeSampleFromPrice.enable && console.log("🎁Active Promo: Free Sample"),
                    t(document).on("cart.requestComplete", function (e, n) {
                        o.freeSampleFromPrice.enable &&
                            (function (e, o) {
                                var n = e.giftQuantity,
                                    i = e.giftId,
                                    a = e.giftHandle,
                                    r = e.trigger,
                                    s = 100 * parseInt(r, 10),
                                    l = !1,
                                    c = !1,
                                    d = !1,
                                    u = void 0,
                                    f = o.total_price,
                                    g = [],
                                    p = e.startDate;
                                console.log("Start date: " + p);
                                var h = e.endDate;
                                console.log("End date: " + h);
                                var m = new Date(),
                                    v = ("0" + (m.getMonth() + 1)).slice(-2) + "/" + ("0" + m.getDate()).slice(-2) + "/" + m.getFullYear() + " " + m.getHours() + ":" + m.getMinutes();
                                console.log("Today's date: " + v),
                                    o.items.forEach(function (e) {
                                        "Gift Card" === e.product_type && ((u = e.line_price), g.push(u), (d = !0));
                                    }),
                                    d &&
                                        ((f -= g.reduce(function (e, t) {
                                            return e + t;
                                        })),
                                        console.log("New Total Price: " + f)),
                                    v >= p &&
                                        v < h &&
                                        t.getJSON("/products/" + a + ".js").done(function () {
                                            if (
                                                (f >= s && (l = !0),
                                                o.items.forEach(function (e) {
                                                    e.variant_id === parseInt(i, 10) && (c = !0);
                                                }),
                                                l && !c)
                                            ) {
                                                var e = {};
                                                (e[i] = n), CartJS.updateItemQuantitiesById(e);
                                            } else !l && c && CartJS.removeItemById(i);
                                        });
                            })(o.freeSampleFromPrice, n);
                    });
            },
            s = function () {
                o.freeSampleFromPrice2.enable && console.log("🎁Active Promo: Free Sample Promo"),
                    t(document).on("cart.requestComplete", function (e, n) {
                        o.freeSampleFromPrice2.enable &&
                            (function (e, o) {
                                var n = e.giftQuantity,
                                    i = e.giftId,
                                    a = e.giftHandle,
                                    r = e.trigger,
                                    s = 100 * parseInt(r, 10),
                                    l = !1,
                                    c = !1,
                                    d = !1,
                                    u = void 0,
                                    f = o.total_price,
                                    g = [],
                                    p = e.startDate;
                                console.log("Start date: " + p);
                                var h = e.endDate;
                                console.log("End date: " + h);
                                var m = new Date(),
                                    v = ("0" + (m.getMonth() + 1)).slice(-2) + "/" + ("0" + m.getDate()).slice(-2) + "/" + m.getFullYear() + " " + m.getHours() + ":" + m.getMinutes();
                                console.log("Today's date: " + v),
                                    o.items.forEach(function (e) {
                                        "Gift Card" === e.product_type && ((u = e.line_price), g.push(u), (d = !0));
                                    }),
                                    d &&
                                        ((f -= g.reduce(function (e, t) {
                                            return e + t;
                                        })),
                                        console.log("New Total Price: " + f)),
                                    v >= p &&
                                        v < h &&
                                        t.getJSON("/products/" + a + ".js").done(function () {
                                            if (
                                                (f >= s && (l = !0),
                                                o.items.forEach(function (e) {
                                                    e.variant_id === parseInt(i, 10) && (c = !0);
                                                }),
                                                l && !c)
                                            ) {
                                                var e = {};
                                                (e[i] = n), CartJS.updateItemQuantitiesById(e);
                                            } else !l && c && CartJS.removeItemById(i);
                                        });
                            })(o.freeSampleFromPrice2, n);
                    });
            },
            l = function (e, n) {
                if (o.birthdayGiftFromCode.enable) {
                    console.log("🎁Active Promo: Birthday Gift Code");
                    var i = window.location.href,
                        a = e.trigger1,
                        r = "birthday_gift_code=" + a;
                    i.indexOf(r) > -1 && (sessionStorage.setItem("birthday_gift_code", a), console.log("Birthday Code Saved")),
                        t(document).on("cart.requestComplete", function (e, n) {
                            !(function (e, o) {
                                var n = e.giftId,
                                    i = e.giftHandle,
                                    a = e.trigger1,
                                    r = e.trigger2,
                                    s = 100 * parseInt(r, 10),
                                    l = sessionStorage.getItem("birthday_gift_code"),
                                    c = !1,
                                    d = !1,
                                    u = !1,
                                    f = void 0,
                                    g = o.total_price,
                                    p = [],
                                    h = e.startDate,
                                    m = e.endDate,
                                    v = new Date(),
                                    _ = ("0" + (v.getMonth() + 1)).slice(-2) + "/" + ("0" + v.getDate()).slice(-2) + "/" + v.getFullYear() + " " + v.getHours() + ":" + v.getMinutes();
                                o.items.forEach(function (e) {
                                    "Gift Card" === e.product_type && ((f = e.line_price), p.push(f), (u = !0));
                                }),
                                    u &&
                                        ((g -= p.reduce(function (e, t) {
                                            return e + t;
                                        })),
                                        console.log("New Total Price: " + g)),
                                    _ >= h &&
                                        _ < m &&
                                        (l === a && g >= s && (c = !0),
                                        t.getJSON("/products/" + i + ".js").done(function () {
                                            if (
                                                (o.items.forEach(function (e) {
                                                    e.variant_id === parseInt(n, 10) && (d = !0);
                                                }),
                                                c && !d)
                                            ) {
                                                var e = {};
                                                (e[n] = 1), CartJS.updateItemQuantitiesById(e);
                                            } else !c && d && CartJS.removeItemById(n);
                                        }));
                            })(o.birthdayGiftFromCode, n);
                        });
                }
            },
            c = function (e, n) {
                if (o.birthdayGiftFromCodeSecond.enable) {
                    console.log("🎁Active Promo: Birthday Gift Coupon");
                    var i = window.location.href,
                        a = e.trigger1,
                        r = "birthday_gift_coupon=" + a;
                    i.indexOf(r) > -1 && (sessionStorage.setItem("birthday_gift_coupon", a), console.log("Birthday Coupon Saved")),
                        t(document).on("cart.requestComplete", function (e, n) {
                            !(function (e, o) {
                                var n = e.giftId,
                                    i = e.giftHandle,
                                    a = e.trigger1,
                                    r = e.trigger2,
                                    s = 100 * parseInt(r, 10),
                                    l = sessionStorage.getItem("birthday_gift_coupon"),
                                    c = !1,
                                    d = !1,
                                    u = !1,
                                    f = void 0,
                                    g = o.total_price,
                                    p = [],
                                    h = e.startDate,
                                    m = e.endDate,
                                    v = new Date(),
                                    _ = ("0" + (v.getMonth() + 1)).slice(-2) + "/" + ("0" + v.getDate()).slice(-2) + "/" + v.getFullYear() + " " + v.getHours() + ":" + v.getMinutes();
                                o.items.forEach(function (e) {
                                    "Gift Card" === e.product_type && ((f = e.line_price), p.push(f), (u = !0));
                                }),
                                    u &&
                                        ((g -= p.reduce(function (e, t) {
                                            return e + t;
                                        })),
                                        console.log("New Total Price: " + g)),
                                    _ >= h &&
                                        _ < m &&
                                        (l === a && g >= s && (c = !0),
                                        t.getJSON("/products/" + i + ".js").done(function () {
                                            if (
                                                (o.items.forEach(function (e) {
                                                    e.variant_id === parseInt(n, 10) && (d = !0);
                                                }),
                                                c && !d)
                                            ) {
                                                var e = {};
                                                (e[n] = 1), CartJS.updateItemQuantitiesById(e);
                                            } else !c && d && CartJS.removeItemById(n);
                                        }));
                            })(o.birthdayGiftFromCodeSecond, n);
                        });
                }
            },
            d = function () {
                o.freeSampling.enable && console.log("🎁Active Promo: Free Sampling Modal"),
                    t(document).on("cart.requestComplete", function (e, n) {
                        o.freeSampling.enable &&
                            (function (e, o) {
                                var n = e.giftId1,
                                    i = e.giftId2,
                                    a = e.giftId3,
                                    r = e.trigger,
                                    giftId4 = e.giftId4,
                                    giftId5 = e.giftId5,
                                    s = 100 * parseInt(r, 10),
                                    l = !1,
                                    c = !1,
                                    d = !1,
                                    u = !1,
                                    hasGift4 = false;
                                    hasGift5 = false;
                                    f = !1,
                                    g = void 0,
                                    p = o.total_price,
                                    h = [],
                                    m = e.startDate;
                                console.log("Start date: " + m);
                                var v = e.endDate;
                                console.log("End date: " + v);
                                var _ = new Date(),
                                    w = ("0" + (_.getMonth() + 1)).slice(-2) + "/" + ("0" + _.getDate()).slice(-2) + "/" + _.getFullYear() + " " + _.getHours() + ":" + _.getMinutes();
                                console.log("Today's date: " + w),
                                    o.items.forEach(function (e) {
                                        "Gift Card" === e.product_type && ((g = e.line_price), h.push(g), (f = !0));
                                    }),
                                    f &&
                                        ((p -= h.reduce(function (e, t) {
                                            return e + t;
                                        })),
                                        console.log("New Total Price: " + p)),
                                    w >= m &&
                                        w < v &&
                                        (p >= s && (l = !0),
                                        o.items.forEach(function (e) {
                                            e.variant_id === parseInt(n, 10) && ((c = !0), console.log("userHasSample1 = true")),
                                                e.variant_id === parseInt(i, 10) && ((d = !0), console.log("userHasSample2 = true")),
                                                e.variant_id === parseInt(a, 10) && ((u = !0), console.log("userHasSample3 = true")),
                                                e.variant_id === giftId4 && ((hasGift4 = !0), console.log("userHasSample4 = true")),
                                                e.variant_id === giftId5 && ((hasGift5 = !0), console.log("userHasSample5 = true"));
                                        }),
                                        !l && c && CartJS.removeItemById(n),
                                        !l && d && CartJS.removeItemById(i),
                                        !l && u && CartJS.removeItemById(a),
                                        !l && hasGift4 && CartJS.removeItemById(giftId4),
                                        !l && hasGift5 && CartJS.removeItemById(giftId5)
                                        );
                            })(o.freeSampling, n);
                    });
            };
        e.init = function () {          
          (o.freeGiftFromProduct = {
              enable: JSON.parse("false"),
              startDate: "01/01/2024 14:00",
              endDate: "12/31/2024 14:00",
              trigger: "39276662489157",
              minPrice: "0",
              giftHandle: "neogen-day-light-protection-airy-sunscreen-2-pack",
              giftId: parseInt("41892528455749"),
          }),
          (o.freeGiftFromPrice = {
              enable: JSON.parse("false"),
              startDate: "10/28/2024 00:01",
              endDate: "12/31/2025 23:59",
              trigger: "",
              giftHandle: "",
              giftId: parseInt(""),
          }),
          (o.freeGiftFromCount = {
              enable: JSON.parse("false"),
              startDate: "",
              endDate: "",
              trigger: "",
              minPrice: "0",
              giftHandle: "",
              giftId: parseInt(""),
          }),
          (o.freeGiftFromType = {
              enable: JSON.parse("false"),
              startDate: "04/10/2023 14:00",
              endDate: "12/18/2023 14:00",
              trigger: "Beauty Water Mist",
              minPrice: "0",
              giftHandle: "beauty-water-60ml-deluxe-sample",
              giftId: parseInt("40598376251461"),
          }),
          (o.freeGiftFromCollection = {
              enable: JSON.parse("false"),
              startDate: "01/01/2024 14:00",
              endDate: "12/30/2024 14:00",
              trigger: window.gwpCollection,
              minPrice: "100",
              giftHandle: "bean-essence-copy",
              giftId: parseInt("42188211486789"),
          }),
          (o.freeGiftFromVendor = {
              enable: JSON.parse("false"),
              startDate: "01/01/2024 14:00",
              endDate: "12/31/2024 14:00",
              trigger: "IOPE",
              minPrice: "50",
              giftHandle: "iope-pdrn-caffeine-shot-7ml-serum",
              giftId: parseInt("41977668862021"),
          }),
          (o.freeSampleFromPrice = {
              enable: JSON.parse("false"),
              startDate: "12/10/2022",
              endDate: "12/30/2022",
              trigger: "75",
              giftHandle: "neogen-dermalogy-day-light-protection-airy-sunscreen-5ml",
              giftId: parseInt("40171951652933"),
              giftQuantity: parseInt("3"),
          }),
          (o.freeSampleFromPrice2 = {
              enable: JSON.parse("false"),
              startDate: "11/28/2019 12:00",
              endDate: "12/02/2019 23:59",
              trigger: "1",
              giftHandle: "danahan-ginseng-seed-secret-essence-sample-1ml",
              giftId: parseInt("29372487237701"),
              giftQuantity: parseInt("3"),
          }),
          (o.birthdayGiftFromCode = {
              enable: JSON.parse("false"),
              startDate: "01/14/2022 08:00",
              endDate: "01/24/2022 23:59",
              trigger1: "SURPRISEGIFT",
              trigger2: "0",
              giftHandle: "prime-time-cleansing-toner-gift-w-purchase",
              giftId: parseInt("39716825595973"),
          }),
          (o.birthdayGiftFromCodeSecond = {
              enable: JSON.parse("true"),
              startDate: "07/01/2022 00:59",
              endDate: "08/01/2022 12:00",
              trigger1: "JUL22",
              trigger2: "1",
              giftHandle: "tonal-scenery-reparative-serum-july-birthday",
              giftId: parseInt("40168919695429"),
          }),
          (o.freeSampling = {
              enable: JSON.parse("false"),
              startDate: "1/19/2023 14:00",
              endDate: "9/10/2023 14:00",
              trigger: "80",
              giftHandle1: "dear-klairs-gentle-black-facial-cleanser-20-ml",
              giftId1: parseInt("39879733936197"),
              giftHandle2: "dear-klairs-supple-preparation-unscented-toner-30ml",
              giftId2: parseInt("39713815232581"),
              giftHandle3: "",
              giftId3: parseInt(""),
              giftHandle4: "",
              giftId4: parseInt(""),
              giftHandle5: "",
              giftId5: parseInt(""),
          });
                  
          t(document).on("click", ".close-gwp-sampling-modal", function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            t(".gwp-modal").hide();
            t("body").removeClass("no-scroll");
          });
          
          var isEnabledDate = function(startDate, endDate) {
            let _ = new Date();
            let now = ("0" + (_.getMonth() + 1)).slice(-2) + "/" + ("0" + _.getDate()).slice(-2) + "/" + _.getFullYear() + " " + _.getHours() + ":" + _.getMinutes();
            
            return startDate <= now && now < endDate;
          };
          
          var isPriceReached = function(trigger) {
            console.log(trigger, "Trigger_____")
            let price = CartJS.cart.total_price;
            
            for (let item of CartJS.cart.items) {
              price -= ("Gift Card" === item.product_type) ? e.line_price : 0;
            }
            
            return price >= (100 * parseInt(trigger, 10));
          };
          
          n.gwpModalTrigger = t("[data-trigger-gwp-modal]"),

          t(document).on("click", "[data-trigger-gwp-modal]", function (e) {
                  e.preventDefault(),
                  e.stopImmediatePropagation(),
                  !0 === t(e.currentTarget).data("trigger-gwp-modal") ? (t(".inline-cart").hide(), t(".overlay").hide(), t("body").addClass("no-scroll"), t(".gwp-modal").show()) : (window.location.href = "/checkout/");
                  !0 === t(e.currentTarget).data("trigger-gwp-modal") ? (window.InlineCart.hide(), t(".gwp-modal").show()) : (window.location.href = "/checkout/");
                  
              e.preventDefault();
              e.stopImmediatePropagation();

              if (!o.freeSampling.enable ||
                  !isEnabledDate(o.freeSampling.startDate, o.freeSampling.endDate) ||
                  !isPriceReached(o.freeSampling.trigger)) {
                window.location.href = "/checkout/";
                
                return;
              }
              
              // Prepares the items in the modal.
              
              t(".gwp-inner-modal-container").removeClass("gwp-samples-container-active");
              t(".gwp-modal-add-to-cart-button").removeClass("gwp-sample-added").text("Add to bag").parent().removeClass("added-gwp-sample");
              t(".gwp-sample-decline").text("No thanks").addClass("gwp-btn-gray");
              
              // Marks the currently selected gift.
              
              for (let item of CartJS.cart.items) {
                if ([o.freeSampling.giftId1, o.freeSampling.giftId2, o.freeSampling.giftId3, o.freeSampling.giftId4, o.freeSampling.giftId5].includes(item.variant_id)) {
                    t(".gwp-inner-modal-container").addClass("gwp-samples-container-active");
                    t(`button[data-gwp-variant-id=${item.variant_id}]`).addClass("gwp-sample-added").text("Remove").parent().addClass("added-gwp-sample");
                    t(".gwp-sample-decline").text("Proceed to Checkout").removeClass("gwp-btn-gray");
                    
                    break;
                }
              }

              window.InlineCart.hide();
              t(".gwp-modal").show();
              t(document.body).addClass("no-scroll");
          }),
        
          t(document).on("click", ".gwp-modal-add-to-cart-button", function (e) {
              e.preventDefault();
              var o = t(e.currentTarget),
                  n = o.attr("data-gwp-variant-id"),
                  i = parseInt(o.attr("data-gwp-qty")) || 1;
              if (o.hasClass("gwp-sample-added")) {
                o.text("Removing...");
                window.CartJS.removeItemById(
                  n,
                  {
                    success: function () {
                      o.removeClass("gwp-sample-added").text("Add to bag"), t(".gwp-sample-decline").text("No thanks").addClass("gwp-btn-gray");
                      t(".gwp-inner-modal-container").removeClass("gwp-samples-container-active");
                      o.parent().removeClass("added-gwp-sample");
                    },
                    error: function (e) {
                      console.log(e);
                    },
                  }
                );

              } else {
                t(".gwp-inner-modal-container").addClass("gwp-samples-container-active"),
                    o.parent().addClass("added-gwp-sample"),
                    void 0 !== n &&
                        "" !== n &&
                        (o.hasClass("gwp-sample-added") ||
                            (o.text("Adding..."),
                            window.CartJS.addItem(
                                n,
                                i,
                                {},
                                {
                                    success: function () {
                                        o.addClass("gwp-sample-added").text("Remove"), t(".gwp-sample-decline").text("Proceed to Checkout").removeClass("gwp-btn-gray");
                                    },
                                    error: function (e) {
                                        console.log(e);
                                    },
                                }
                            )));
              }
          }),
        
          a(),
          r(),
          s(),
          l(o.birthdayGiftFromCode),
          c(o.birthdayGiftFromCodeSecond),
          d(),
          i();
        };
    })((window.FreeGift = window.FreeGift || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {};
        (e.disableMissingVendors = function () {
            o.vendorGroup.each(function (e, o) {
                var n = t(o).attr("data-vendor-group"),
                    i = t("[data-vendor-toggle='" + n + "']");
                i.addClass("is-available"), i.removeAttr("disabled");
            });
        }),
            (e.displayVendorGroup = function (e) {
                o.vendorListContainer.addClass("is-active"),
                    t("[data-vendor-group='" + e + "']").addClass("is-active"),
                    t("[data-vendor-group='" + e + "']")
                        .siblings()
                        .removeClass("is-active");
            });
        e.init = function () {
            (o.globalHeader = t("[data-global-header]")),
                (o.globalPromoBar = t("[data-global-promo-bar]")),
                (o.vendorListContainer = t("[data-vendor-list-container]")),
                (o.vendorToggleTarget = t("[data-vendor-toggle]")),
                (o.vendorGroup = t("[data-vendor-group]")),
                (o.mainNavItemsContainer = t("[data-main-nav-items-container]")),
                (o.mainNavItem = t("[data-main-nav-item]")),
                (o.mainNavLink = t("[data-main-nav-link]")),
                (o.subNav = t("[data-subnav]")),
                (o.featuredBanners = t("[data-subnav-featured-banners]")),
                (o.searchToggle = t("[data-search-toggle]")),
                (o.searchBarOverlay = t(".header-search__search-overlay")),
                (o.searchInputDiv = t(".header-search__input-wrapper")),
                (o.searchInput = t(".header-search__input")),
                o.vendorToggleTarget.on("click", function (n) {
                    var i = t(n.currentTarget),
                        a = i.closest(o.subNav).find(o.featuredBanners);
                    e.displayVendorGroup(i.attr("data-vendor-toggle")), a.hide();
                }),
                o.globalHeader.on("mouseenter", function (e) {
                    var n = t(e.currentTarget),
                        i = o.searchBarOverlay.hasClass("is-active");
                    n.hasClass("white-bg") ? i || n.removeClass("white-bg") : n.addClass("white-bg");
                }),
                o.globalHeader.on("mouseleave", function (e) {
                    var n = t(e.currentTarget);
                    o.searchBarOverlay.hasClass("is-active") || n.removeClass("white-bg");
                }),
                o.mainNavItem.on("mouseenter", function (e) {
                    t(e.currentTarget).hasClass("has-subnav") ? o.mainNavItemsContainer.addClass("has-subnav") : o.mainNavItemsContainer.removeClass("has-subnav");
                }),
                o.mainNavItem.on("mouseleave", function (e) {
                    t(e.currentTarget).removeClass("show-subnav");
                }),
                o.mainNavLink.on("mouseenter", function (e) {
                    t(e.currentTarget).parent().addClass("show-subnav");
                }),
                t(window).scroll(function () {
                    var e = o.globalPromoBar.outerHeight(),
                        n = document.querySelector(".snize-ac-results");
                    t(this).scrollTop() > e
                        ? (t("body").addClass("scrolled"), o.globalHeader.addClass("scrolled"), n && n.classList.add("body-scrolled"))
                        : (n && n.classList.remove("body-scrolled"), o.globalHeader.removeClass("scrolled"), t("body").removeClass("scrolled"));
                }),
                e.disableMissingVendors();
        };
    })((window.Header = window.Header || {}), jQuery),
    (function (e, t) {
        "use strict";
        (e.debounce = function (e, t, o) {
            var n = void 0;
            return function () {
                var i = this,
                    a = arguments,
                    r = o && !n;
                clearTimeout(n),
                    (n = setTimeout(function () {
                        (n = null), o || e.apply(i, a);
                    }, t)),
                    r && e.apply(i, a);
            };
        }),
            (e.handlize = function (e) {
                e = e.toLowerCase();
                for (var t = ['"', "'", "\\", "(", ")", "[", "]", "$"], o = 0; o < t.length; ++o) e = e.replace(t[o], "");
                return "-" == (e = e.replace(/\W+/g, "-")).charAt(e.length - 1) && (e = e.replace(/-+\z/, "")), "-" == e.charAt(0) && (e = e.replace(/\A-+/, "")), e;
            });
    })((window.Helpers = window.Helpers || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {},
            n = CartJS.cart;
        e.pendingRequestCount = 0;
        (e.update = function (n) {
            t.get("/cart?view=contents").then(function (t) {
                o.inlineCart.html(t), e.itemCountTotal(), "function" == typeof n && n();
            });
        }),
            (e.itemCountTotal = function () {
                CartJS.cart.item_count;
                o.cartItemCount.text(n.item_count);
            }),
            (e.checkForGWP = function () {
                CartJS.cart.item_count;
                o.cartItemCount.text(n.item_count);
            }),
            (e.show = function () {
                o.inlineCart.addClass("is-active"), Overlay.show(), Scroll.lock(), Quickshop.hide();
            }),
            (e.hide = function () {
                o.inlineCart.removeClass("is-active"), Overlay.hide(), Scroll.unlock();
            }),
            (e.toggle = function () {
                e.update(), o.inlineCart.hasClass("is-active") ? e.hide() : e.show();
            }),
            (e.removeItem = function (t) {
                CartJS.updateItemById(t, 0, null, {
                    success: function (t, o, n) {
                        e.update();
                    },
                    error: function (e, t, o) {
                        //window.alert("Sorry, we're unable to do that.\n" + JSON.parse(e.responseText).description);
                    },
                });
            });
        e.init = function () {
            (o.inlineCart = t("[data-inline-cart]")),
                (o.lineItemEntryPoint = t("[data-cart-contents]")),
                (o.inlineCartToggle = t("[data-inline-cart-toggle]")),
                (o.overlay = t("[data-overlay]")),
                (o.cartItemCount = t("[data-cart-item-count]")),
                t(document).on("click", "[data-inline-cart-toggle]", function (t) {
                    e.toggle();
                }),
                t(document).on("cart.requestStarted", function (t, o) {
                    e.pendingRequestCount += 1;                    
                    
                    // Block the checkout button while there are pending requests.                   
                    let btn = document.querySelector("a[data-checkout-btn]");
                    
                    // if (btn != null) {                     
                    //   btn.classList.add("disabled-checkout-btn");
                      
                    //   console.log('inline cart checkout disabled');
                    // }
                }),
                t(document).on("cart.requestComplete", function (t, o) {
                    e.update(
                      // Enable the checkout button when all pending requests have been completed.
                      function() {
                        e.pendingRequestCount -= 1;
                        
                        let btn = document.querySelector("a[data-checkout-btn]");
                        
                        if (btn == null) return;                       
                    
                        if (e.pendingRequestCount == 0) {
                          btn.classList.remove("disabled-checkout-btn");
                          
                          console.log('inline cart checkout enabled');
                        } else {
                          // Keeps the button disabled in the updated HTML.
                          // btn.classList.add("disabled-checkout-btn");
                        }                        
                      }
                    );
                }),
                t(document).on("click", "[data-cart-remove]", function (o) {
                  console.log("GWP removed check________________")
                    // $(`.line-item-free[data-line-item="${gwp_coll_one_gift_handle}"]`).remove()
                    // console.log($(`.line-item-free[data-line-item="${gwp_coll_one_gift_handle}"]`).remove(), "remove item")
                    var n = t(o.currentTarget),
                        i = n.closest("[data-line-item]"),
                        a = n.attr("data-variant-id");
                        e.removeItem(a), i.remove();  
                        var free_line_item_collection = $('.line-item-free').data('collection')
                    //    Code for cart total remove start
                        console.log(gwp_cart_total_enable, "gwp_cart_total_enable")
                        if(gwp_cart_total_enable){
                            fetch('/cart.js')
                                .then(response => response.json())
                                .then(data => {
                                    setTimeout(function(){
                                        // let cart_sub_total = CartJS.cart.total_price / 100;
                                        let cart_sub_total;
                                        let check_gift_card = CartJS.cart.items
                                        $(check_gift_card).each(function(elm, value){
                                            if (value.gift_card == true) {
                                                  let gift_card_price =  value.final_price / 100; 
                                                  cart_sub_total = CartJS.cart.total_price / 100;
                                                  cart_sub_total = cart_sub_total - gift_card_price
    
                                            }else{
                                                cart_sub_total = CartJS.cart.total_price / 100
                                            }
                                        }); 

                                        if(cart_sub_total < gwp_cart_total_amount){
                                            console.log("Cart Total removed2")
                                            e.removeItem(gwp_cart_total_gift_id), $(`.line-item-free[data-line-item="${gwp_cart_total_gift_handle}"]`).remove();
                                        }else if(cart_sub_total >= gwp_cart_total_amount){
                                            let cartItemsGift = CartJS.cart.items
                                                                    let gift_cart_total_id_check = false;
                                                                        $(cartItemsGift).each(function(elem, value){
                                                                            if(value.id == gwp_cart_total_gift_id){
                                                                                gift_cart_total_id_check = true
                                                                            } else if (value.gift_card == true){
                                                                                gift_cart_total_id_check = true
                                                                            }
                                                                        });
                                                                        if(!gift_cart_total_id_check){
                                                                        CartJS.addItem(gwp_cart_total_gift_id, 1, {}, {
                                                                                    "success": function(data, textStatus, jqXHR) {
                                                                                    console.log("Cart Total Gift product added")
                                                                                    },
                                                                                    "error": function(jqXHR, textStatus, errorThrown) {
                                                                                        console.log("Cart Total Gift product Error")
                                                                                    }
                                                                        });
                                                                    }
                                        }
                                    }, 2000);
                                })
                                .catch(error => {
                                    console.error('Error fetching cart JSON:', error);
                                });
                      
                        }  
                        //    Code for cart total remove End

                        // Code for GWP collections remove item start 
                    
                        if(gwp_one_enable || gwp_two_enable || gwp_three_enable || gwp_four_enable){
                            setTimeout(() => {                
                                    let cart_Items =  document.querySelectorAll("[data-inline-cart] .cart__line-items .line-item:not(.line-item-free)"); 
                                    let collectionItem2 = [];
                                    let gift_card = false;
                                    $(cart_Items).each(function(el, val){
                                        if(val.classList.contains('line-item-gift-card')){
                                                gift_card = true;
                                            }
                                            let price = $(val).find('.line-item__price').text();
                                            let quantity = $(val).find('[data-line-item-quantity]').val();
                                            price = Number(price.split('$')[1]);
                                            if(val.dataset.collection == gwp_coll_one_title ){
                                                let obj = {
                                                    collection: gwp_coll_one_title,
                                                    price: price ? price * quantity : 0,
                                                    thresold: gwp_coll_one_amount, 
                                                }
                                                collectionItem2.push(obj);
                                            } else if(val.dataset.collection == gwp_coll_two_title){
                                                let obj = {
                                                    collection: gwp_coll_two_title,
                                                      price: price ? price * quantity : 0,
                                                    thresold: gwp_coll_two_amount,
                                                }
                                                collectionItem2.push(obj);
                                            }else if(val.dataset.collection == gwp_coll_three_title){
                                                let obj = {
                                                    collection: gwp_coll_three_title,
                                                      price: price ? price * quantity : 0,
                                                    thresold: gwp_coll_three_amount,
                                                }
                                                collectionItem2.push(obj);
                                            }
                                            else if(val.dataset.collection == gwp_coll_four_title){
                                                let obj = {
                                                    collection: gwp_coll_four_title,
                                                      price: price ? price * quantity : 0,
                                                    thresold: gwp_coll_four_amount
                                                }
                                                collectionItem2.push(obj);
                                            } 
                                    });
                        
                                        const totals = collectionItem2.reduce((acc, item) => {
                                            if (acc[item.collection]) {
                                                acc[item.collection] += item.price;
                                            } else {
                                                acc[item.collection] = item.price;
                                            }
                                            return acc;
                                        }, {});
                                
                                        console.log(totals, "REMOVE ITEM____")
                                    if(gwp_one_enable){
                                        if(totals[gwp_coll_one_title] < gwp_coll_one_amount){
                                            console.log(totals[gwp_coll_one_title], gwp_coll_one_amount, "Thresold amount 1 remove")
                                            e.removeItem(gwp_coll_one_gift_id), $(`.line-item-free[data-line-item="${gwp_coll_one_gift_handle}"]`).remove();
                                            // var getfree_lineid_1 = parseInt($(`.line-item-free[data-variant-id="${gwp_coll_one_gift_handle}"]`).attr('data-line-number'));
                                            // CartJS.updateItem(getfree_lineid_1, 0);

                                        }
                                    }
                                    if(gwp_two_enable){
                                        if(totals[gwp_coll_two_title] < gwp_coll_two_amount){    
                                            console.log(totals[gwp_coll_two_title], gwp_coll_two_amount, "Thresold amount 2 remove")
                                            e.removeItem(gwp_coll_two_gift_id), $(`.line-item-free[data-line-item="${gwp_coll_two_gift_handle}"]`).remove();
                                       } else{
                                        if(!gift_card){
                                          CartJS.addItem(gwp_coll_two_gift_id, 1, {}, {
                                                                          "success": function(data, textStatus, jqXHR) {
                                                                          console.log("Remove Two collection gift product added")
                                                                          },
                                                                          "error": function(jqXHR, textStatus, errorThrown) {
                                                                              console.log("Two Error")
                                                                          }
                                              });
                                            }
                                      }
                                    }
                                    if(gwp_three_enable){
                                        if(totals[gwp_coll_three_title] < gwp_coll_three_amount){    
                                            console.log(totals[gwp_coll_three_title], gwp_coll_two_amount, "Thresold amount 3 remove")
                                            e.removeItem(gwp_coll_three_gift_id), $(`.line-item-free[data-line-item="${gwp_coll_three_gift_handle}"]`).remove();
                                       }else{
                                        if(!gift_card){
                                          CartJS.addItem(gwp_coll_three_gift_id, 1, {}, {
                                                                          "success": function(data, textStatus, jqXHR) {
                                                                          console.log("Remove three collection gift product added")
                                                                          },
                                                                          "error": function(jqXHR, textStatus, errorThrown) {
                                                                              console.log("Two Error")
                                                                          }
                                              });
                                            }
                                      }
                                    }
                                    if(gwp_four_enable){
                                        if(totals[gwp_coll_four_title] < gwp_coll_four_amount){    
                                            console.log(totals[gwp_coll_four_title], gwp_coll_two_amount, "Thresold amount 4 remove")
                                            e.removeItem(gwp_coll_four_gift_id), $(`.line-item-free[data-line-item="${gwp_coll_four_gift_handle}"]`).remove();
                                       }else{ 
                                        if(!gift_card){
                                          CartJS.addItem(gwp_coll_four_gift_id, 1, {}, {
                                                                          "success": function(data, textStatus, jqXHR) {
                                                                          console.log("remove four collection gift product added")
                                                                          },
                                                                          "error": function(jqXHR, textStatus, errorThrown) {
                                                                              console.log("Two Error")
                                                                          }
                                              });
                                            }
                                      }
                                    }
                                }, 1000);
                        }  
                        
                        // Code for GWP collections remove item End
                        
                                // Code for Free sample page remove start 
                                if(enable_free_sample_page){
                                    setTimeout(function(){
                                    fetch('/cart.js')
                                        .then(response => response.json())
                                        .then(data => {
                                                let cart_sub_total;
                                                let check_gift_card = data.items
                                                $(check_gift_card).each(function(elm, value){
                                                    if (value.gift_card == true) {
                                                        let gift_card_price =  value.final_price / 100; 
                                                        cart_sub_total = data.total_price / 100;
                                                        cart_sub_total = cart_sub_total - gift_card_price
            
                                                    }else{
                                                        cart_sub_total = data.total_price / 100
                                                    }
                                                }); 
                                                console.log(cart_sub_total, free_sample_cart_total_amount, "Free sampling total value")
                                                if(cart_sub_total < free_sample_cart_total_amount){
                                                    console.log("Cart Total removed3")
                                                    $(check_gift_card).each(function(elmm, valmm){
                                                        if(valmm.id == free_sample_product_1){
                                                            e.removeItem(free_sample_product_1), $(`.line-item-free[data-line-item="${free_sample_product_1_handle}"]`).remove();
                                                        }else if(valmm.id == free_sample_product_2){
                                                            e.removeItem(free_sample_product_2), $(`.line-item-free[data-line-item="${free_sample_product_2_handle}"]`).remove();
                                                        }else if(valmm.id == free_sample_product_3){
                                                            e.removeItem(free_sample_product_3), $(`.line-item-free[data-line-item="${free_sample_product_3_handle}"]`).remove();
                                                        }else if(valmm.id == free_sample_product_4){
                                                            e.removeItem(free_sample_product_4), $(`.line-item-free[data-line-item="${free_sample_product_4_handle}"]`).remove();
                                                        }
                                                    });
 
                                                }else if(cart_sub_total >= free_sample_cart_total_amount){
                                                    let check_gift_prd = false
                                                    setTimeout(function(){
                                                    $(check_gift_card).each(function(elmm1, valmm1){
                                                            if(valmm1.gift_card == true){
                                                                check_gift_prd = true
                                                            }
                                                        });
                                                        if(check_gift_prd){
                                                            $('#sample-page-trigger').attr('href', '/checkout');
                                                        }else{
                                                            $('#sample-page-trigger').attr('href', '/pages/free-sampling-page');   
                                                        }
                                                    }, 1500)

                                                  
                                                }
                                            })
                                            .catch(error => {
                                                console.error('Error fetching cart JSON:', error);
                                            });
                                        }, 2000);
                            
                                }  
                                // Code for Free sample page remove end
                       

                }),
                t(document).on("focusin", "[data-line-item-quantity]", function () { 
                    t(this).data("val", t(this).val());
                }),
                t(document).on("change", "[data-line-item-quantity]", function () {
                    console.log("cart change"); 
                    t(this).data("val");
                    var e = t(this).val(),
                        o = (t(event.currentTarget), t(this).closest(".line-item").attr("data-line-number"));
                    CartJS.cart.total_price, CartJS.updateItem(o, e);
                    console.log( CartJS.updateItem(o, e), "Cart item updated")

                }),
                t(document).on("click", "[data-inline-cart-gift-note-toggle]", function (e) {
                    t(".js-inline-cart-gift-note-container").toggleClass("show-inline-cart-gift-note-container");
                }),
                t(document).on("click", "[data-checkout-btn]", function (e) {
                    e.preventDefault(), console.log("click");
                    var o = t('[name="note"]').val() || !1;
                    console.log("note:", o),
                        o
                            ? CartJS.setNote(o, {
                                  success: function (e, t, o) {
                                      window.location = "/checkout";
                                  },
                              })
                            : (window.location = "/checkout");
                }),
                e.update();
        };
    })((window.InlineCart = window.InlineCart || {}), jQuery),
    (function (e, t) {
        e.init = function () {
            new e();
        };
    })((window.LazyLoad = window.LazyLoad || {}), jQuery);
var _typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (e) {
              return typeof e;
          }
        : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          };
!(function (e, t) {
    "use strict";
    var o = {},
        n = function () {
            "object" === ("undefined" == typeof theme ? "undefined" : _typeof(theme)) &&
                "function" == typeof theme.matchHeight &&
                setTimeout(function () {
                    theme.matchHeight();
                }, 1);
        };
    e.init = function () {
        (o.matchHeight = t(".js-match-height")), o.matchHeight.on("click", n);
    };
})((window.MatchHeight = window.MatchHeight || {}), jQuery),
    (function (e, t) {
        var o = {};
        (e.show = function () {
            o.mobileNavToggle.addClass("is-active"), o.mobileNav.addClass("is-active"), Scroll.lock(), Overlay.show();
        }),
            (e.hide = function () {
                o.mobileNavToggle.removeClass("is-active"), o.mobileNav.removeClass("is-active"), Scroll.unlock(), Overlay.hide();
            });
        e.init = function () {
            (o.mobileNavToggle = t("[data-mobile-nav-toggle]")),
                (o.mobileNav = t("[data-mobile-nav]")),
                (o.navLink = t("[data-nav-link]")),
                o.navLink.on("click", function (e) {
                    window.dataLayer = window.dataLayer || [];
                    var o = t(e.currentTarget),
                        n = o.attr("data-parent-item"),
                        i = o.attr("data-nav-link"),
                        a = "";
                    (a = n ? n + ", " + n + " > " + i : i), console.log(a), window.dataLayer.push({ event: "Nav Click", navItem: a }), e.stopPropagation();
                }),
                o.mobileNavToggle.on("click", function (o) {
                    t(o.currentTarget).hasClass("is-active") ? e.hide() : e.show();
                }),
                t("[data-open-subnav]").on("click", function (e) {
                    e.preventDefault(), t(e.currentTarget).next("[data-subnav]").addClass("is-active");
                }),
                t("[data-close-subnav]").on("click", function (e) {
                    e.preventDefault(), t(e.currentTarget).closest("[data-subnav]").removeClass("is-active");
                });
        };
    })((window.MobileNav = window.MobileNav || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {};
        (e.show = function (e) {
            return window.Overlay.show(), window.Scroll.lock(), o.body.attr("data-active-modal", e), t('[data-modal="' + e + '"]').fadeIn(300);
        }),
            (e.hide = function () {
                return window.Overlay.hide(), window.Scroll.unlock(), o.body.removeAttr("data-active-modal"), o.modal.fadeOut(300);
            });
        e.init = function () {
            (o.body = t("body")),
                (o.modal = t("[data-modal]")),
                (o.modalShow = t("[data-modal-show]")),
                (o.modalHide = t("[data-modal-hide]")),
                o.modalShow.on("click", function (e) {
                    e.preventDefault(), window.Modal.show(t(this).attr("data-modal-show"));
                }),
                o.modalHide.on("click", function (e) {
                    e.preventDefault(), window.Modal.hide();
                });
        };
    })((window.Modal = window.Modal || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {},
            n = function (e) {
                var t = e.find(".email").val();
                return !!t.length && t;
            },
            i = function (e, t) {
                var o = e.find(".js-newsletter-response");
                switch (t) {
                    case "subscribe":
                        o.html("Thank you for signing up!");
                        break;
                    case "success":
                        o.html("Thank you for signing up!");
                        break;
                    case "error":
                        o.html("We're sorry. Something went wrong, please try again.");
                }
            },
            a = function (e) {
                e.preventDefault();
                var o = t(e.currentTarget);
                i(o, "subscribe");
                var a,
                    r = n(o),
                    s =
                        !!(a = o
                            .find('[name="SKINTYPE"]:checked')
                            .map(function (e, t) {
                                return t.value;
                            })
                            .get()
                            .join(", ")).length && a;
                if (r) {
                    var l = {
                        email: r,
                        lists: { "Subscribed 5718": 1 },
                        vars: {},
                        onSuccess: function () {
                            i(o, "success");
                        },
                        onError: function () {
                            i(o, "error");
                        },
                    };
                    s && (l.vars["SkinSignUp"] = s);
                } else i(o, "error");
            };
        (e.init = function () {
            (o.newsletter = t(".js-newsletter")), o.newsletter.on("submit", a);
        }),
            (e.submitPdfForm = function (e) {
                e.preventDefault();
                var o = t(e.currentTarget);
                i(o, "subscribe");
                var a = n(o);
                if (a) {
                    var r = {
                        email: a,
                        lists: { "Subscribed 5718": 1 },
                        vars: {},
                        onSuccess: function () {
                            t(".downloadPdf-modal").removeClass("showModal"),
                                t(".modalbackground").removeClass("showModal"),
                                (window.location.href = "https://cdn.shopify.com/s/files/1/0249/1218/files/Soko_Glam_10-Step_Skincare_Routine.pdf?4470562713874017923"),
                                i(o, "success");
                        },
                        onError: function () {
                            i(o, "error");
                        },
                    };
                } else i(o, "error");
            });
    })((window.Newsletter = window.Newsletter || {}), jQuery),
    (function (e, t) {
        var o = window.productJson || {},
            n = function (t, o) {
                e.updateATC({ variant: t, selector: o });
            };
        (e.updateATC = function (e) {
            var o = e.variant,
                n = (e.selector, t("[data-add-to-cart]")),
                i = t("#ProductPrice"),
                a = t("#ComparePrice"),
                r = (t(".product-qty"), t("#AddToCartText"));
            ($pdpWishlist = t(".pdp-atc-form__wishlist")),
                ($pdpQtyContainer = t(".pdp-atc-form__qty")),
                o &&
                    (n.attr("data-variant-id", o.id),
                    n.attr("data-add-to-cart", ""),
                    o.available
                        ? (n.removeClass("pdp-sold-out-btn").removeAttr("id", "BIS_trigger_Listrak"),
                          r.html("ADD TO BAG"),
                          $pdpWishlist.show(),
                          $pdpQtyContainer.show(),
                          t("#main-product-detail .ProductPrice, #quickshop .ProductPrice").text(Shopify.formatMoney(o.price)))
                        : (n.addClass("pdp-sold-out-btn").attr("id", "BIS_trigger_Listrak").removeAttr("data-add-to-cart"),
                          r.html("EMAIL ME WHEN IN STOCK"),
                          $pdpWishlist.hide(),
                          $pdpQtyContainer.hide(),
                          t(".quickshop-inner .add-to-cart-btn-text").html("This product is unavailable")),
                    i.html(Shopify.formatMoney(o.price)),
                    o.compare_at_price > o.price ? a.html(Shopify.formatMoney(o.compare_at_price, moneyFormat)).show() : a.hide());
        }),
            (e.dummySelect = function () {
                ($selectWrap = t("[data-cart-submit] .selector-wrapper")),
                    $selectWrap.each(function () {
                        var e = t(this),
                            o = e.find("label"),
                            n = e.find("select"),
                            i = o.text().toLowerCase(),
                            a = e.find("option:selected"),
                            r = n.find("option"),
                            s = t('<ul class="dummy-select option-' + i + '"></ul>'),
                            l = o.length > 0 ? o.text() : a.text(),
                            c = t('<div class="selection">' + l + "</div>");
                        setTimeout(function () {
                            r.each(function (e, o) {
                                var n,
                                    a = t(o);
                                (n = a.hasClass("disabled") ? "disabled" : ""),
                                    s.append('<li class="' + n + '" val="' + a.attr("value") + '" data-dummy-index="' + e + '"><span class="' + i + "-" + Shopify.handleize(a.attr("value")) + '"></span>' + a.text() + "</li>");
                            }),
                                e.prepend(s),
                                e.prepend(c),
                                o.add(n).hide();
                        }, 0),
                            $selectWrap.on("click", "li", function () {
                                var o = (e = t(this)).attr("val"),
                                    i = e.text();
                                c.text(i).removeClass("show"),
                                    s.stop().slideUp(250),
                                    n.val(o).trigger("change"),
                                    t(".note", ".submit-row").hide(),
                                    (color_len = s.find("li").length),
                                    (img_len = t(".thumbnails").find("li").not(".slick-cloned").length),
                                    (img_len_mobile = t(".thumbnails").find(".slick-slide").not(".slick-cloned").length),
                                    (img_offset = img_len - color_len),
                                    (img_offset_mobile = img_len_mobile - color_len),
                                    (index = e.index() + img_offset),
                                    (index_mobile = e.index() + img_offset_mobile),
                                    t(".thumbnail").eq(index).click(),
                                    t(".thumbnails").slick("slickGoTo", index_mobile);
                            }),
                            c.click(function () {
                                (e = t(this)).toggleClass("show"), s.stop().slideToggle(250);
                            });
                    });
            }),
            (e.modifyFormView = function () {
                (o = window.productJson || {}), t('[data-product-options="Title"]').hide();
                var e = o.variants[0].title,
                    n = o.options[0],
                    i = o.options.length;
                1 == o.options.length && "Title" != o.options[0] && t(".selector-wrapper:eq(0)").prepend('<label for="productSelect-option-0">' + n + "</label>"),
                    -1 !== e.indexOf("Default Title") ? (t(".selector-wrapper:eq(0)").hide(), t(".product-form").addClass("options-0")) : t(".product-form").addClass("options-" + i),
                    t.each(o.variants, function (e, n) {
                        1 === o.options.length &&
                            !n.available &&
                            t(".selector-wrapper:eq(0) option:eq(" + e + ")")
                                .attr("disabled", "disabled")
                                .addClass("disabled");
                    });
            }),
            (e.init = function () {
                new Shopify.OptionSelectors("productSelect", { product: window.productJson, onVariantSelected: n, enableHistoryState: !1 }), e.modifyFormView();
            });
    })((window.OptionSelection = window.OptionSelection || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {};
        (e.show = function () {
            return o.overlay.fadeIn(300);
        }),
            (e.hide = function () {
                return o.overlay.fadeOut(300);
            }),
            (e.toggle = function () {
                return o.overlay.fadeToggle(300);
            });
        e.init = function () {
            (o.overlay = t("[data-overlay]")),
                o.overlay.on("click", window.Overlay.hide),
                o.overlay.on("click", window.Modal.hide),
                o.overlay.on("click", window.Quickshop.hide),
                o.overlay.on("click", window.InlineCart.hide),
                o.overlay.on("click", window.MobileNav.hide),
                o.overlay.on("click", window.Filter.hide),
                t(".js-close-pdp-modal").on("click", window.Overlay.hide),
                t(".js-close-pdp-modal").on("click", window.Modal.hide);
        };
    })((window.Overlay = window.Overlay || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {};
        e.init = function () {
            (o.qtyControl = t("[qty-control]")),
                (o.qtyInput = t("[qty-input]")),
                (o.descriptionFull = t(".tab-content--full")),
                (o.descriptionShort = t(".tab-content--short")),
                (o.tabShowMore = t("[data-show-more]")),
                (o.tabShowLess = t("[data-show-less]")),
                o.tabShowMore.on("click", function (e) {
                    e.preventDefault();
                    var n = t(e.currentTarget).closest(".pdp-tab-content"),
                        i = n.find(o.descriptionFull),
                        a = n.find(o.descriptionShort);
                    i.show(), a.hide();
                }),
                o.tabShowLess.on("click", function (e) {
                    e.preventDefault();
                    var n = t(e.currentTarget).closest(".pdp-tab-content"),
                        i = n.find(o.descriptionFull),
                        a = n.find(o.descriptionShort);
                    i.hide(), a.show();
                });
        };
    })((window.Product = window.Product || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {},
            n = { slidesToShow: 1, slidesToScroll: 1, dots: !0, arrows: !0, infinite: !1 },
            i = function () {
                o.quickshop.find("#quickshop-main-slider").slick(n), o.quickshop.find(".slick-prev").click();
            },
            a = function () {
                console.log("Quickshop - Product", window.productJson),
                    "Title" !== window.productJson.options[0] &&
                        setTimeout(function () {
                            var e;
                            (e = o.quickshop.find(".selector-wrapper")).each(function () {
                                var o = t(this),
                                    n = o.find("label"),
                                    i = o.find("select"),
                                    a = n.text().toLowerCase(),
                                    r = o.find("option:selected"),
                                    s = i.find("option"),
                                    l = t('<ul class="dummy-select option-' + a + '"></ul>'),
                                    c = n.length > 0 ? n.text() : r.text(),
                                    d = t('<div class="selection">' + c + "</div>");
                                setTimeout(function () {
                                    s.each(function (e, o) {
                                        var n,
                                            i = t(o);
                                        (n = i.hasClass("disabled") ? "disabled" : ""),
                                            l.append('<li class="' + n + '" val="' + i.attr("value") + '" data-dummy-index="' + e + '"><span class="' + a + "-" + Shopify.handleize(i.attr("value")) + '"></span>' + i.text() + "</li>");
                                    }),
                                        o.prepend(l),
                                        o.prepend(d),
                                        n.add(i).hide();
                                }, 0),
                                    setTimeout(function () {
                                        var n = (o = t(".selector-wrapper li:first-child")).attr("val"),
                                            a = o.text();
                                        o
                                            .closest(e)
                                            .find(d)
                                            .html(c + ": <div class='selection-current'>" + a + "</div>"),
                                            o.addClass("is-active").siblings().removeClass("is-active"),
                                            i.val(n).trigger("change");
                                    }, 0),
                                    e.on("click", "li", function () {
                                        var n = (o = t(this)).attr("val"),
                                            a = o.text();
                                        o
                                            .closest(e)
                                            .find(d)
                                            .html(c + ": <div class='selection-current'>" + a + "</div>"),
                                            o.addClass("is-active").siblings().removeClass("is-active"),
                                            i.val(n).trigger("change");
                                    });
                            });
                        }, 500);
            },
            r = function () {
                new Yotpo.API(yotpo).refreshWidgets();
            },
            s = function (e) {
                var n, i, r;
                o.quickshop.html(e),
                    a(),
                    (n = t(".description--see-more")),
                    (i = t(".description--text-summary")),
                    (r = t(".description--text-full")),
                    n.on("click", function (e) {
                        e.preventDefault(), i.toggleClass("hide"), r.toggleClass("hide"), n.hide();
                    });
            },
            l = function () {
                o.quickshopTrigger.on("click", function () {
                    var o;
                    (o = t(this).attr("data-product-handle")),
                        t
                            .get("/products/" + o + "?view=quickshop")
                            .then(s)
                            .then(i)
                            .then(r)
                            .then(Overlay.show)
                            .then(OptionSelection.init)
                            .done(e.show);
                });
            };
        (e.show = function () {
            o.quickshop.fadeToggle(200);
        }),
            (e.hide = function () {
                o.quickshop.hide();
            }),
            (e.init = function () {
                (o.quickshop = t("[data-quickshop]")), (o.quickshopTrigger = t("[data-trigger-quickshop]")), l();
            });
    })((window.Quickshop = window.Quickshop || {}), jQuery),
    (function (e, t) {
        e.init = function () {
            t(".js-routine-steps-container")
                .find(".js-routine-link-1")
                .on("mouseenter", function () {
                    t(".js-routine-steps-container").addClass("step-3-bottle-active");
                }),
                t(".js-routine-steps-container")
                    .find(".js-routine-link-1")
                    .on("mouseleave", function () {
                        t(".js-routine-steps-container").removeClass("step-3-bottle-active");
                    }),
                t(".js-routine-steps-container")
                    .find(".js-routine-link-2")
                    .on("mouseenter", function () {
                        t(".js-routine-steps-container").addClass("step-5-bottle-active");
                    }),
                t(".js-routine-steps-container")
                    .find(".js-routine-link-2")
                    .on("mouseleave", function () {
                        t(".js-routine-steps-container").removeClass("step-5-bottle-active");
                    }),
                t(".js-routine-steps-container")
                    .find(".js-routine-link-3")
                    .on("mouseenter", function () {
                        t(".js-routine-steps-container").addClass("step-10-bottle-active");
                    }),
                t(".js-routine-steps-container")
                    .find(".js-routine-link-3")
                    .on("mouseleave", function () {
                        t(".js-routine-steps-container").removeClass("step-10-bottle-active");
                    });
        };
    })((window.RoutineStepsSection = window.RoutineStepsSection || {}), jQuery),
    (function (e, t) {
        "use strict";
        (e.lock = function (e) {
            t("html, body").addClass("no-scroll");
        }),
            (e.unlock = function (e) {
                t("html, body").removeClass("no-scroll");
            }),
            (e.toggle = function (e) {
                t("html, body").toggleClass("no-scroll");
            });
        e.init = function () {};
    })((window.Scroll = window.Scroll || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {};
        (e.checkString = function (e) {
            var t = e.toLowerCase().split(" ").join("");
            window.location.href = "son&park" == t ? "/search?type=product&q=" + encodeURIComponent("Son & Park").replace(/%20/g, "%2B") : "/search?type=product&q=" + e.split(" ").join("+");
        }),
            (e.toggleBar = function () {
                o.searchTrigger.toggleClass("active"), o.searchOverlay.toggleClass("is-active"), o.cartFlyout.hide(), o.cartTrigger.removeClass("active");
            });
        var n = function (e) {
            if (e > 991) {
                var t = document.querySelector(".snize-ac-results");
                t && "none" != t.style.display ? document.body.classList.contains("noscroll") || document.body.classList.add("noscroll") : document.body.classList.remove("noscroll");
            } else {
                document.querySelector(".header-search__search-overlay").classList.contains("is-active") ? document.body.classList.add("noscroll") : document.body.classList.remove("noscroll");
            }
        };
        e.init = function () {
                (o.searchForm = t("#header-search form")),
                (o.searchTrigger = t(".menu__search")),
                (o.headerSearchTrigger = t(".global-header .menu__search")),
                (o.searchForm = t("#header-search")),
                (o.searchInput = t(".header-search__input")),
                (o.searchOverlay = t(".header-search__search-overlay")),
                (o.searchClear = t(".header-search__clear-icon")),
                (o.cartFlyout = t("#cart-flyout")),
                (o.cartTrigger = t(".menu__cart")),
                (o.mobileMenuSearchIcon = t(".mobile-nav__header-item.menu__search")),
                (o.mobileToggler = t('.snize-custom-widget-opener'));
                t(window).on("mousemove", function () {
                    n(window.innerWidth);
                }),
                t(window).on("touchstart", function () {
                    n(window.innerWidth);
                }),
                o.searchForm.submit(function (t) {
                    t.preventDefault();
                    var n = t.target?.querySelector('[type="search"]')?.value
                    // var n = i.searchForm.serializeArray()[1].value;
                    e.checkString(n);
                }),
                o.searchTrigger.click(function (t) {
                    e.toggleBar(), o.searchInput.focus();
                }),
                o.mobileToggler.click(function(t){
                    e.toggleBar(), o.searchInput.focus();
                })
                o.searchClear.click(function (t) {
                    "" !== o.searchInput.val() ? (o.searchInput.val(""), o.searchInput.focus()) : e.toggleBar();
                }),
                o.mobileMenuSearchIcon.hide();
        };
    })((window.Search = window.Search || {}), jQuery),
    (function (e, t) {
        e.init = function () {
            t(".js-shop-by-tab-content-container")
                .find(".js-shop-by-heading-container")
                .on("click", function () {
                    t(this).toggleClass("is-active").next().slideToggle(), t(this).toggleClass("opened");
                }),
                t(document).ready(function () {
                    t(".shop-tab-title:first-child").addClass("is-active-title"),
                        t(".js-shop-by-tab-content-container:nth-child(1)").show(),
                        t(".js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(4)").hide();
                }),
                t(".js-shop-by-main-tab-container")
                    .find(".shop-tab-title:nth-child(1)")
                    .on("click", function () {
                        t(this).toggleClass("is-active-title"),
                            t(this).hasClass("is-active-title") &&
                                (t(".js-shop-by-tab-content-container:nth-child(1)").show(),
                                t(".shop-tab-title:nth-child(3), .shop-tab-title:nth-child(2), .shop-tab-title:nth-child(4)").removeClass("is-active-title"),
                                t(".js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(4)").hide(),
                                t(".js-shop-by-tab-tiles-container").slick("setPosition"));
                    }),
                t(".js-shop-by-main-tab-container")
                    .find(".shop-tab-title:nth-child(2)")
                    .on("click", function () {
                        t(this).toggleClass("is-active-title"),
                            t(this).hasClass("is-active-title") &&
                                (t(".js-shop-by-tab-content-container:nth-child(2)").show(),
                                t(".shop-tab-title:nth-child(1), .shop-tab-title:nth-child(3), .shop-tab-title:nth-child(4)").removeClass("is-active-title"),
                                t(".js-shop-by-tab-content-container:nth-child(1), .js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(4)").hide(),
                                t(".js-shop-by-tab-tiles-container").slick("setPosition"));
                    }),
                t(".js-shop-by-main-tab-container")
                    .find(".shop-tab-title:nth-child(3)")
                    .on("click", function () {
                        t(this).toggleClass("is-active-title"),
                            t(this).hasClass("is-active-title") &&
                                (t(".js-shop-by-tab-content-container:nth-child(3)").show(),
                                t(".shop-tab-title:nth-child(1), .shop-tab-title:nth-child(2), .shop-tab-title:nth-child(4)").removeClass("is-active-title"),
                                t(".js-shop-by-tab-content-container:nth-child(1), .js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(4)").hide(),
                                t(".js-shop-by-tab-tiles-container").slick("setPosition"));
                    }),
                t(".js-shop-by-main-tab-container")
                    .find(".shop-tab-title:nth-child(4)")
                    .on("click", function () {
                        t(this).toggleClass("is-active-title"),
                            t(this).hasClass("is-active-title") &&
                                (t(".js-shop-by-tab-content-container:nth-child(4)").show(),
                                t(".shop-tab-title:nth-child(1), .shop-tab-title:nth-child(2), .shop-tab-title:nth-child(3)").removeClass("is-active-title"),
                                t(".js-shop-by-tab-content-container:nth-child(1), .js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(3)").hide(),
                                t(".js-shop-by-tab-tiles-container").slick("setPosition"));
                    });
        };
    })((window.ShopBySection = window.ShopBySection || {}), jQuery),
    (function (e, t) {
        var o = {},
            n = window.innerWidth <= 782,
            i = { slidesToShow: 1, arrows: !1, dots: !0, autoplay: !0, autoplaySpeed: 8e3, pauseOnHover: !1, responsive: [{ breakpoint: 783, settings: { dots: !1 } }] },
            a = { slidesToShow: 4, slidesToScroll: 1, arrows: !0, dots: !1, infinite: !1, responsive: [{ breakpoint: 783, settings: "unslick" }] },
            r = { slidesToShow: 1, slidesToScroll: 1, fade: !1, arrows: !0, autoplay: !0, autoplaySpeed: 6e3, asNavFor: ".js-press-logo-slider-container", responsive: [{ breakpoint: 783, settings: { arrows: !1, dots: !1 } }] },
            s = { slidesToShow: 4, slidesToScroll: 1, asNavFor: ".js-press-quote-slider-container", dots: !1, arrows: !1, focusOnSelect: !0, responsive: [{ breakpoint: 783, settings: { slidesToShow: 1, dots: !0 } }] },
            l = { slidesToShow: 1, dots: !1, arrows: !1, adaptiveHeight: !0 },
            c = { slidesToShow: 1, slidesToScroll: 1, dots: !0, arrows: !0, infinite: !1, asNavFor: ".pdp-thumbnail__aside", responsive: [{ breakpoint: 768, settings: { adaptiveHeight: !0 } }] },
            d = { slidesToShow: 17, slidesToScroll: 1, dots: !1, arrows: !0, asNavFor: "[pdp-main-slider]", focusOnSelect: !0 },
            u = { slidesToShow: 4, slidesToScroll: 1, arrows: !0, dots: !1, infinite: !0, responsive: [{ breakpoint: 1024, settings: { slidesToShow: 2 } }] },
            f = function () {
                o.homeShopBySlider.slick(a);
            };
        e.init = function () {
            t(window).on("load resize orientationchange", function () {
                t(".js-promo-tile-grid-container, .js-the-klog-articles-container").each(function () {
                    var e = t(this);
                    t(window).width() >= 783 ? e.hasClass("slick-initialized") && e.slick("unslick") : e.hasClass("slick-initialized") || e.slick({ slidesToShow: 1, slidesToScroll: 1, mobileFirst: !0, arrows: !0, dots: !0 });
                });
            }),
                t(window).on("load resize orientationchange", function () {
                    t(".js-account--nav__control-bar-inner-orders").each(function () {
                        var e = t(this);
                        t(window).width() >= 992
                            ? e.hasClass("slick-initialized") && e.slick("unslick")
                            : e.hasClass("slick-initialized") || e.slick({ infinite: !1, slidesToShow: 2, slidesToScroll: 1, mobileFirst: !0, arrows: !0, dots: !1 });
                    });
                }),
                t(window).on("load resize orientationchange", function () {
                    t(".js-account--nav__control-bar-inner-info").each(function () {
                        var e = t(this);
                        t(window).width() >= 992
                            ? e.hasClass("slick-initialized") && e.slick("unslick")
                            : e.hasClass("slick-initialized") || e.slick({ infinite: !1, slidesToShow: 2, slidesToScroll: 1, mobileFirst: !0, arrows: !0, dots: !1, initialSlide: 1 });
                    });
                }),
                t(window).on("load resize orientationchange", function () {
                    t(".js-account--nav__control-bar-inner-addresses").each(function () {
                        var e = t(this);
                        t(window).width() >= 992
                            ? e.hasClass("slick-initialized") && e.slick("unslick")
                            : e.hasClass("slick-initialized") || e.slick({ infinite: !1, slidesToShow: 2, slidesToScroll: 1, mobileFirst: !0, arrows: !0, dots: !1, initialSlide: 2 });
                    });
                }),
                t(window).on("resize", function (e) {
                    window.innerWidth > 782 ? n && (f(), (n = !1)) : n || (n = !0);
                }),
                (o.homeHeroSlider = t(".js-homepage-slider-container")),
                (o.homeShopBySlider = t(".js-shop-by-tab-tiles-container")),
                (o.homePressQuoteSlider = t(".js-press-quote-slider-container")),
                (o.homePressLogoSlider = t(".js-press-logo-slider-container")),
                (o.tenStepLandingPageSlider = t(".slides__container")),
                (o.pdpMainSlider = t("[pdp-main-slider]")),
                (o.pdpThumbnailSlider = t(".pdp-thumbnail__aside")),
                (o.pdpRelatedProductsSlider = t("[pdp-related-products-slider]")),
                o.homeHeroSlider.slick(i),
                o.homeShopBySlider.slick(a),
                o.homePressQuoteSlider.slick(r),
                o.homePressLogoSlider.slick(s),
                o.tenStepLandingPageSlider.slick(l),
                o.pdpMainSlider.slick(c),
                o.pdpThumbnailSlider.slick(d),
                o.pdpRelatedProductsSlider.slick(u);
        };
    })((window.Sliders = window.Sliders || {}), jQuery),
    (function (e, t) {
        e.init = function () {
            t(".smoothScroll").click(function () {
                var e = t(this).data("scroll-to"),
                    o = t('[data-scroll-target="' + e + '"]');
                console.log(e), console.log(o), t("html, body").animate({ scrollTop: o.offset().top + -80 }, 600);
            }),
                t(".js-hero-view-more-icon-container").click(function () {
                    t("html, body").animate({ scrollTop: t(".js-shop-carousel-container").offset().top + -60 }, 600);
                });
        };
    })((window.SmoothScroll = window.SmoothScroll || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {},
            n = function (e) {
                var o = t(e.currentTarget),
                    n = o.attr("data-index");
                t(".slides__container").slick("slickGoTo", n), a(768), o.css("background-color", "#FCF4FA"), t(window).width() < 992 && o.css("border-right", "2px solid #EC138D");
            };
        function i(e) {
            var o = (function (e) {
                    var o = t('<span class="tempforSize">' + e + "</span>").prependTo("body"),
                        n = o.width();
                    return o.remove(), n;
                })(e.children(":selected").html()),
                n = e.width() - o;
            e.css("text-indent", n / 2 - 10);
        }
        var a = function (e) {
                t(".selector__item").each(function (o, n) {
                    t(n).css("background-color", "white"),
                        t(n).css("border-right", "none"),
                        t(window).width() <= e
                            ? (t(".slides__container").css("display", "block"),
                              t(n).find(".selector__icon").css("display", "none"),
                              t(n).find(".selector__title").css("display", "none"),
                              t(".slides__container").css("flex", "1"),
                              t(".selector__back").css("display", "flex"),
                              t(".selector__backbtn").css("display", "block"),
                              t(".selector").css("width", "auto"),
                              t(".vertical__box").each(function (e, o) {
                                  return t(o).css("display", "none");
                              }))
                            : (t(n).find(".selector__icon").css("display", "block"), t(n).find(".selector__title").css("display", "block"));
                });
            },
            r = function (e) {
                e.preventDefault();
                var t = e.currentTarget.previousElementSibling,
                    o = e.currentTarget;
                t.classList.toggle("toggle-height"), "READ MORE" === o.innerText ? (o.innerText = "READ LESS") : (o.innerText = "READ MORE");
            },
            s = function (e) {
                e.preventDefault();
                var o = t(e.currentTarget).parent().next();
                "none" == o.css("display") ? (o.slideDown(), t(".routine__down-arrow").text("-")) : (t(".routine__down-arrow").text("+"), o.slideUp());
            },
            l = function (e) {
                var o = Helpers.handlize(t(e.currentTarget).val()),
                    n = "/collections/shop-routine-" + o;
                t.get(n, function (e) {
                    t(".routine__container").html(e), t(".routine__down-arrow").on("click", s), t(".js-category-btn").text("Shop all " + o + " Skin"), t(".js-category-btn").attr("href", "/collections/" + o);
                });
            },
            c = function () {
                var e = t(".skintype-select-js").val(),
                    o = "/collections/shop-routine-" + e;
                t.get(o, function (o) {
                    t(".routine__container").html(o), t(".routine__down-arrow").on("click", s), t(".js-category-btn").text("Shop all " + e + " Skin"), t(".js-category-btn").attr("href", "/collections/" + e);
                }),
                    t(t(".selector__item")[0]).css("background-color", "#FCF4FA"),
                    t(window).width() < 992 && t(t(".selector__item")[0]).css("border-right", "2px solid #EC138D");
            },
            d = function (e) {
                e.preventDefault(),
                    "block" === t(e.currentTarget).css("display") &&
                        (t(e.currentTarget).css("display", "none"),
                        t(".selector__back").css("display", "none"),
                        t(".selector__item").each(function (e, o) {
                            t(o).find(".selector__icon").css("display", "block"),
                                t(o).find(".selector__title").css("display", "block"),
                                t(".slides__container").css("flex", "none"),
                                t(".slides__container").css("display", "none"),
                                t(".selector").css("width", "100%"),
                                t(".vertical__box").each(function (e, o) {
                                    t(o).css("display", "block");
                                });
                        }));
            };
        t(".slides__container").on("afterChange", function (e, o, n) {
            a(768), t(t(".selector__item")[n]).css("background-color", "#FCF4FA"), t(window).width() < 992 && t(t(".selector__item")[n]).css("border-right", "2px solid #EC138D");
        }),
            t(".step__next-btn").on("click", function (e) {
                e.preventDefault();
                var o = t(e.currentTarget).parent().index();
                t(".slides__container").slick("slickGoTo", o), a(768), t(t(".selector__item")[o]).css("background-color", "#FCF4FA"), t(window).width() < 992 && t(t(".selector__item")[o]).css("border-right", "2px solid #EC138D");
            }),
            t(".routine__btn").on("click", function (e) {
                e.preventDefault(), t(".skintype-modal").addClass("showModal"), t(".modalbackground").addClass("showModal");
            }),
            t(".skintype-modal__exit, .skintype-modal__btn").on("click", function (e) {
                e.preventDefault(), t(".skintype-modal").removeClass("showModal"), t(".modalbackground").removeClass("showModal");
            }),
            t(".downloadPdf-modal__exit").on("click", function (e) {
                e.preventDefault(), t(".downloadPdf-modal").removeClass("showModal"), t(".modalbackground").removeClass("showModal");
            });
        e.init = function () {
            (o.selectorItem = t(".selector__item")),
                (o.stepNext = t(".step__next-btn")),
                (o.readMoreBtn = t("[data-read-more-btn]")),
                o.selectorItem.click(n),
                o.readMoreBtn.on("click", r),
                t(".routine__down-arrow").on("click", s),
                t(".skintype-select-js").on("change", l),
                t(".selector__backbtn").on("click", d),
                t(".skintype-select-js").each(function () {
                    i(t(this));
                }),
                t(".skintype-select-js").on("change", function () {
                    i(t(this));
                }),
                t("#downloadPdf-modal__form").submit(Newsletter.submitPdfForm),
                t(window).resize(function () {
                    t(window).width() < 992 || t(".routine__list").slideDown();
                }),
                t(document).ready(c);
        };
    })((window.TenStepLandingPage = window.TenStepLandingPage || {}), jQuery),
    (function (e, t) {
        var o = t(".venobox").venobox();
        e.init = function () {
            t(".venobox").venobox(),
                t(document).on("click", ".closeme", function (e) {
                    o.VBclose();
                });
        };

        t(document).on("click", "#cart__closebtn", function (e) {
         window.Overlay.hide();
         window.Modal.hide();
         window.Quickshop.hide();
         window.InlineCart.hide();
         window.MobileNav.hide();
         window.Filter.hide();
        });
    })((window.VenoboxModals = window.VenoboxModals || {}), jQuery);
